<template>
  <div class="card">
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col-md-6">
          <strong class="card-title mb-3">{{ 'Mutual Funds Data ' }} - {{ selSchemeTab }} - <b class="ml-2"> {{
            last_updated_date }} </b> </strong>
        </div>
        <div class="col-md-5">
          <div class="mr5 pull-right"><a href="#/mutual-funds/p-trends" class="btn btn-sm btn-small btn-secondary"><i
                title="P Trends" class="fa fa-area-chart cwhite"></i></a></div>
        </div>
        <div class="col-md-1">
          <goback></goback>
          <!-- <div class="pull-right">
            <router-link class="btn btn-sm" :to="'/mutual-funds/rawdata'"><i class="fa fa-caret-left"></i> Go Back</router-link>
          </div> -->
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-6">
          <div class="form-group">
            <v-select :options="schemeList" :placeholder="'Select Scheme'" :label="'name'" v-model="selScheme"
              @input="getSchemeRawData">
            </v-select>
          </div>
        </div>
      </div>
      <div class="row mb5">
        <div class="col-md-6">
        </div>
      </div>
      <vue-tabs v-model="selSchemeTab" direction="horizontal" @tab-change="getTabData">
        <spinner v-if="isloading"></spinner>
        <v-tab :title="rd.value" v-for="(rd, index) in rawDataList" v-bind:key="index">
          <div class="mb10"></div>
          <div class="mb5" v-if="selScheme && selScheme != null">
            <div class="row">
              <div class="col-md-12">
                <h4 class="text-center">{{ selScheme.id }} - {{ selScheme.name }}</h4>
              </div>
            </div>
          </div>
          <div class="mb5"></div>
          <div class="row mb5" v-if="checkInArray(dateFilterTabs, rawDataType)">
            <div class="col-md-3" v-if="rawDataType !== 'analysis-sum-latest'">
              <div class="form-group">
                <datepicker :input-class="'form-control'" :format="'dd-MM-yyyy'" v-model="durDate"
                  @selected="getDateData($event)" :disabledDates="disabledDates" :placeholder="'Select Date'">
                </datepicker>
              </div>
            </div>
            <div class="col-md-9">
              <button v-if="rawDataType === 'analysis'" type="button" class="btn btn-primary float-right"
                @click="updateRunAnalysis">Update</button>
            </div>
          </div>
          <div class="row mb5" v-if="checkInArray(dateFilterTabs, rawDataType)">
            <div class="col-md-3" v-if="rawDataType !== 'analysis-sum-latest'">
              <div class="form-group">
                <v-select :options="durDateList" :placeholder="'Select Date'" v-model="durDate"
                  @input="getDateData($event)"></v-select>
              </div>
            </div>
          </div>
          <div class="row mb-5" v-if="rawDataType === 'scheme-rolling-returns'">
            <div class="col-md-4">
              <div class="form-group">
                <v-select :options="durationForRollingReturns" :placeholder="'Select Duration'" v-model="selDuration"
                  @input="getRollingDuration($event)"></v-select>
              </div>
            </div>
          </div>
          <div class="row mb5" v-if="rawDataType !== 'analysis'">
            <div class="col-md-3" v-if="rawDataType !== 'whats-in-out'">
              <span v-if="rawData.date"><strong>Date: {{ rawData.date ? getDate(rawData.date) : '' }}</strong></span>
            </div>
            <div class="col-md-4" v-if="rawDataType !== 'whats-in-out'">
              <span v-if="rawData.portfolio_overall_rating"><strong>Portfolio Overall Rating:</strong>
                {{ rawData.portfolio_overall_rating ? getChecknFixed(rawData.portfolio_overall_rating) : '' }}</span>
            </div>
            <!-- <div class="col-md-3" v-if="rawDataType!== 'whats-in-out'">
              <span v-if="rawData.avg_maturity"><strong>Average Maturity:</strong> {{getChecknFixed(rawData.avg_maturity)}} <br>{{rawData.avg_maturity_date? getDate(rawData.avg_maturity_date): ''}}</span>
            </div>
            <div class="col-md-2" v-if="rawDataType == 'whats-in-out' && tableFields.length">
              <button class="btn btn-default" v-if="tableFields.length" @click="showWhatsIn = !showWhatsIn">Show {{(showWhatsIn)? 'Whats Out':'Whats In'}}</button>
            </div>-->
            <div class="col-md-10" v-if="rawDataType == 'whats-in-out'"></div>
            <div class="col-md-5">
              <download :tableId="'mf' + rawDataType"
                :fileName="rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')"></download>
            </div>
            <div class="col-md-2"
              v-if="rawDataType === 'scheme-nav-historical' || rawDataType === 'scheme-rolling-returns'">
              <div class="pull-right"><button class="btn btn-sm" @click="downLoadAll">Download All</button></div>
            </div>
          </div>
          <div class="row mb5" v-if="rawDataType === 'analysis'">
            <div class="col-md-2">
              <span v-if="rawData.length"><strong>Date: {{ rawData.length ? getDate(sum['date']) : '' }}</strong></span>
            </div>
            <div class="col-md-3">
              <span v-if="rawData.length"><strong>Sum P11 S (% hldg):</strong> {{ rawData.length ?
                getChecknFixed(sum['p11_S_%_hldg_sum']) : '' }}</span>
            </div>
            <div class="col-md-3">
              <span v-if="rawData.length"><strong>Sum P11 quarterly trends (% hldg):</strong> {{ rawData.length ?
                getChecknFixed(sum['p11_quarterly_trends_%_hldg_sum']) : '' }}</span>
            </div>
            <div class="col-md-3">
              <span v-if="rawData.length"><strong>Sum QA Or QB Greater (% hldg):</strong> {{ rawData.length ?
                getChecknFixed(sum['q1_a_b_greater_%_hldg_sum']) : '' }}</span>
            </div>
            <div class="col-md-1">
              <download :tableId="'mf' + rawDataType" :fileName="rawDataType"></download>
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-3">
              <span v-if="rawData.length"><strong>Debt rating (% hldg):</strong> {{ rawData.length ?
                getChecknFixed(sum['p11_debt_%_hldg_sum']) : '' }}</span>
            </div>
            <div class="col-md-3">
              <span v-if="rawData.length"><strong>Portfolio Overall Rating:</strong> {{ rawData.length ?
                getChecknFixed(sum.portfolio_overall_rating) : '' }}</span>
            </div>
          </div>
          <!--- Pagination ---------->
          <div class="row" v-if="rawDataList[selRowInd].isPaginate">
            <div class="col-md-6"></div>
            <div class="col-md-6">
              <div class="pull-right">
                <ul v-if="totalPages != 1" class="pagination">
                  <li :class="{ disabled: prevDisabled }" class="page-item">
                    <a class="page-link" @click.prevent="goToPage(1)" href="#">&lt;&lt;</a>
                  </li>
                  <li :class="{ disabled: prevDisabled }" class="page-item">
                    <a class="page-link" @click.prevent="prev()" href="#">&lt;</a>
                  </li>
                  <li v-for="page in pages" v-bind:key="page" class="page-item"
                    :class="(current_page == page) ? 'active' : ''">
                    <a class="page-link" @click.prevent="goToPage(page)" href="#">{{ page }}</a>
                  </li>
                  <li :class="{ disabled: nextDisabled }" class="page-item">
                    <a class="page-link" href="#" @click.prevent="next()">&gt;</a>
                  </li>
                  <li :class="{ disabled: nextDisabled }" class="page-item">
                    <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">&gt;&gt;</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!--- END Pagination ---------->
          <div v-if="rawDataType === 'basic'">
            <table :id="'mf' + rawDataType" class="table table-bordered fonts11 app-inner">
              <thead>
                <tr>
                  <th style="width:30%;">Basic Detail</th>
                  <th style="width:70%;">Scheme Name</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in tableFields" :key="index">
                  <td>{{ item.label }}</td>
                  <td>{{ item.value }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-responsive scrollbar app mb5" v-dragscroll="true"
            v-if="rawDataType != 'basic' && tableFields.length && rawDataType != 'scheme-rolling-returns' && rawDataType != 'scheme-return-ranks' && rawDataType != 'scheme-returns' && rawDataType != 'whats-in-out' && rawDataType != 'scheme-asset-allocation' && rawDataType != 'sector-historical'">
            <table :id="'mf' + rawDataType" class="table table-bordered fonts11 app-inner">
              <thead>
                <tr v-if="selScheme && selScheme != null" style="visibility:hidden">
                  <th
                    :colspan="rawDataType !== 'analysis-sum' && rawDataType !== 'analysis-sum-latest' ? tableFields.length + 1 : tableFields.length">
                    {{ selScheme.name }}
                  </th>
                </tr>
                <tr>
                  <th v-if="rawDataType !== 'analysis-sum' && rawDataType !== 'analysis-sum-latest'">Sr.</th>
                  <th class="data-cell" v-for="(field, index, key) in tableFields"
                    v-bind:key="'field' + field.rowind + index + key">{{ field.name }}</th>
                  <th v-if="actions.length">Actions</th>
                  <th v-for="(field, index) in ratings.subFields" v-bind:key="'ratingsth' + field.title + index">
                    {{ field.name }}
                    <i class="fa fa-caret-down" v-if="(field.sort == 1 || field.sort == 0)"></i>
                    <i class="fa fa-caret-up" v-else-if="(field.sort == 2 || field.sort == 0)"></i>
                  </th>
                </tr>
              </thead>
              <tbody v-if="rawDataType !== 'analysis-sum' && rawDataType !== 'analysis-sum-latest'">
                <tr v-if="rawDataType === 'basic'">
                  {{ rawData }}
                </tr>
                <tr v-else v-for="(tr, ind) in rawData" v-bind:key="'trBod' + '-' + ind">
                  <td>
                    <span v-if="rawDataType == 'schemes'">
                      <span v-if="page > 1">{{ (perPage * (page - 1)) + (ind + 1) }}</span>
                      <span v-else>{{ ind + 1 }}</span>
                    </span>
                    <span v-else>{{ ind + 1 }}</span>
                  </td>
                  <td v-for="(cl, index) in tableFields" v-bind:key="index + 'cldata' + cl.title">
                    <span v-if="cl.isLink">
                      <!-- <a class="a-btn" @click.prevent="showSchemeHoldings(tr[cl.title])">{{tr[cl.title]}}</a> -->
                      <router-link class="a-btn" :to="'/mutual-funds/schemeholdings/' + tr[cl.title]" target="_blank">{{
                        tr[cl.title] }}</router-link>
                    </span>
                    <!-- <span v-else-if="rawDataType == 'scheme-holdings' && cl.title == 'CO_NAME'">{{tr['CO_NAME']}} {{(tr['CO_CODE'])? ' ('+(tr['CO_CODE'])+')': '-'}}
                    </span>
                    <span v-else-if="rawDataType == 'scheme-holdings' && cl.title == 'MKTVALUE'">{{(tr[cl.title])? (tr[cl.title]): '-'}}<br/> {{(tr['NO_SHARES'])? '(' + tr['NO_SHARES'] +')': ''}}</span> -->
                    <span v-else>
                      <!-- getDate(item[ci][field.key]) -->
                      <span v-if="cl.datatype == 'date'"> {{ (tr[cl.title]) ? tr[cl.title].split('T')[0] : '-' }}</span>
                      <!-- <span v-if="cl.datatype=='date'"> {{(tr[cl.title])? getDate(tr[cl.title]): '-'}}</span> -->
                      <span v-else-if="cl.datatype == 'numeric'">{{ getChecknFixed(tr[cl.title]) }}</span>
                      <span v-else-if="cl.datatype == 'object'">{{ (tr[cl.title] && tr[cl.title][0] &&
                        tr[cl.title][0].Category) ? tr[cl.title][0].Category : '' }}</span>
                      <span v-else-if="cl.datatype == 'rating'">
                        <star-rating v-bind:increment="0.5" v-bind:max-rating="(cl.title == 'p11_rating') ? 7 : 5"
                          :rating="parseInt(tr[cl.title])" :read-only="true" :show-rating="false"
                          inactive-color="#868e96" active-color="#ffbf00" v-bind:star-size="20"></star-rating>
                      </span>
                      <span v-else>{{ (tr[cl.title]) ? (tr[cl.title]) : '-' }}</span>
                    </span>
                  </td>
                  <td v-if="actions.length">
                    <div class="action-btn-wrapper" v-for="action in actions" v-bind:key="'action' + action.tooltip">
                      <span v-if="action.isLink">
                        <router-link style="margin:1px 4px" class="a-btn" :class="action.btnClass"
                          :to="action.url + tr[action.param]" :target="action.isNewWindow ? '_blank' : ''"
                          :title="action.tooltip"> {{ action.tooltip }}
                        </router-link>
                      </span>
                      <span v-else><a style="margin:1px 4px" class="a-btn" :class="action.btnClass"
                          @click.prevent="action.callback(tr['mf_schcode'])" :title="action.tooltip"> {{ action.tooltip
                          }}
                        </a></span>
                    </div>
                  </td>
                </tr>
                <tr v-if="rawDataType === 'analysis' && rawData.length && sum.date">
                  <td class="text-bold">SUM</td>
                  <td class="text-bold" v-for="(cl, index) in tableFields" v-bind:key="index + 'cldata' + cl.title">
                    <span v-if="cl.title == 'PERC_HOLD'">{{ getChecknFixed(analysisPercHold) }}</span>
                    <span v-else-if="cl.datatype == 'numeric'">{{ (sum[cl.title + '_sum']) ? getChecknFixed(sum[cl.title
                      +
                      '_sum']) :
                      '-' }}</span>
                    <span v-else>{{ (sum[cl.title + '_sum']) ? sum[cl.title + '_sum'] : '' }}</span>
                  </td>
                </tr>
                <tr v-if="rawDataType === 'scheme-holdings' && rawData.length">
                  <td class="text-bold">SUM</td>
                  <td class="text-bold" v-for="(cl, index) in tableFields" v-bind:key="index + 'cldata' + cl.title">
                    <span v-if="cl.title == 'PERC_HOLD'">{{ getChecknFixed(schemeHoldingsPercHold) }}</span>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td v-for="(cl, index) in tableFields" v-bind:key="index + 'cldata' + cl.title" class="text-bold">
                    <span v-if="cl.datatype == 'numeric'">{{ (rawData[cl.title + '_sum']) ?
                      getChecknFixed(rawData[cl.title + '_sum']) : (rawData[cl.title]) ?
                        getChecknFixed(rawData[cl.title]) :
                        '-' }}</span>
                    <span v-else-if="cl.datatype == 'date'">{{ (rawData[cl.title + '_sum']) ?
                      getDate(rawData[cl.title + '_sum']) : (rawData[cl.title]) ? getDate(rawData[cl.title]) :
                        '-' }}</span>
                    <span v-else-if="cl.datatype == 'rating'">
                      <star-rating v-bind:increment="0.5" v-bind:max-rating="(cl.title == 'p11_rating') ? 7 : 5"
                        :rating="parseInt(tr[cl.title])" :read-only="true" :show-rating="false" inactive-color="#868e96"
                        active-color="#ffbf00" v-bind:star-size="20"></star-rating>
                    </span>
                    <span v-else>{{ (rawData[cl.title + '_sum']) ? rawData[cl.title + '_sum'] : (rawData[cl.title]) ?
                      rawData[cl.title] : '' }}</span>
                  </td>
                  <td v-for="(cl, index) in ratings.subFields" v-bind:key="'ratingstd' + cl.title + index">
                    <span v-if="cl.datatype == 'numeric'">
                      {{ (rawData['ratings']['raw'][cl.title]) ? (rawData['ratings']['raw'][cl.title]) : '-' }}
                      {{ (rawData['ratings']['label'][cl.title]) ? '(' + (rawData['ratings']['label'][cl.title]) + ')' :
                        '-' }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row mb5 mt10 table-responsive scrollbar mb5" v-if="rawDataType === 'scheme-rolling-returns'">
            <table class="table table-bordered font11" :id="'mf' + rawDataType">
              <thead>
                <tr v-if="selScheme && selScheme != null">
                  <th>
                    {{ selScheme.name }}
                  </th>
                  <th>{{ selDuration }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Last Calculated Date</td>
                  <td>{{ last_updated_date }}</td>
                </tr>
                <tr>
                  <td>Lastest Calculated Date</td>
                  <td>{{ latest_date_used_for_calc }}</td>
                </tr>
                <tr v-for="(schemeRolling, ind) in schemeRollingTableFields" v-bind:key="'schemeRolling' + ind">
                  <td v-if="schemeRolling.dataType == 'display'" class="text-bold">{{ schemeRolling.name }}</td>
                  <td v-else class="text-bold">{{ schemeRolling.name }}</td>
                  <td>
                    <span v-if="schemeRolling.dataType == 'date'"> {{
                      rawData[schemeRolling.title][schemeRolling.sub_title] ?
                        getDate(rawData[schemeRolling.title][schemeRolling.sub_title]) : '-' }} </span>
                    <span
                      v-else-if="schemeRolling.dataType == 'numeric' && rawData[schemeRolling.title] && rawData[schemeRolling.title][schemeRolling.sub_title]">
                      {{ getChecknFixed(rawData[schemeRolling.title][schemeRolling.sub_title]) }}</span>
                    <!-- <span v-else-if="schemeRolling.dataType == 'display'"><strong>{{schemeRolling.name}}</strong></span> -->
                    <span v-else>
                      <!-- {{ rawData[schemeRolling.title][schemeRolling.sub_title]}} -->
                    </span>
                  </td>
                </tr>
                <tr>
                  <td class="text-bold">Totals</td>
                  <td></td>
                </tr>
                <tr>
                  <td class="text-bold">Total Rows</td>
                  <td v-if="rawData['totals'] && rawData['totals']['rows']">{{ rawData['totals']['rows'] }}</td>
                </tr>
                <tr v-for="(schemeRollingRows, schemerollRowInd) in schemeRollingTableRows"
                  :key="'schemRollRows' + schemerollRowInd">
                  <td>{{ schemeRollingRows.name }}</td>
                  <td>{{ (rawData['totals']) ? rawData['totals'][schemeRollingRows.title] : '-' }}</td>
                </tr>
                <tr>
                  <td class="text-bold">Totals (In %)</td>
                  <td></td>
                </tr>
                <!-- <tr><td class="text-bold">Total Rows</td><td>{{rawData['totals']['rows']}}</td></tr> -->
                <tr v-for="(schemeRollingRows, schemerollRowInd) in schemeRollingTableRowsPercent"
                  :key="'schemRollRowsperc' + schemerollRowInd">
                  <td>{{ schemeRollingRows.name }}</td>
                  <td>{{ (rawData['totals'] && rawData['totals']['percent']) ?
                    getFixed(rawData['totals']['percent'][schemeRollingRows.title]) : '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row mb5 mt10 table-responsive scrollbar mb5"
            v-if="tableFields.length && rawDataType === 'scheme-asset-allocation'">
            <table class="table table-bordered font11" :id="'mf' + rawDataType">
              <thead>
                <tr v-if="selScheme && selScheme != null" style="visibility:hidden">
                  <th
                    :colspan="rawDataType !== 'analysis-sum' && rawDataType !== 'analysis-sum-latest' ? tableFields.length + 1 : tableFields.length">
                    {{ selScheme.name }}
                  </th>
                </tr>
                <tr>
                  <th v-for="(field, ind) in tableFields" v-bind:key="'ratingth' + ind">{{ field.title }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, ind) in rawData" v-bind:key="'ratingt' + ind">
                  <td v-for="(field, ci) in tableFields" v-bind:key="'sector' + ci">
                    <span v-if="field.data_type == 'date'"> {{ item[ci][field.key] ? getDate(item[ci][field.key]) : '-'
                    }}
                    </span>
                    <span v-else-if="field.data_type == 'numeric'">{{ getChecknFixed(item[ci][field.key]) }}</span>
                    <span v-else-if="field.data_type == 'perc'">
                      {{ item[ci][field.key] ? getFixed2dec(item[ci][field.key]) + '%' : '-' }}
                    </span>
                    <span v-else>
                      {{ item[ci][field.key] }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-responsive scrollbar app mb5" v-dragscroll="true"
            v-else-if="tableFields.length && rawDataType == 'whats-in-out'">
            <div class="row">
              <div class="col-md-12">
                <h3>Whats In</h3>
              </div>
            </div>
            <table :id="'mf' + rawDataType" class="table table-bordered fonts11 app-inner">
              <thead>
                <tr v-if="selScheme && selScheme != null" style="visibility:hidden">
                  <th
                    :colspan="rawDataType !== 'analysis-sum' && rawDataType !== 'analysis-sum-latest' ? tableFields.length + 1 : tableFields.length">
                    {{ selScheme.name }}
                  </th>
                </tr>
                <tr>
                  <th>Sr.</th>
                  <th class="data-cell" v-for="(field, index, key) in tableFields"
                    v-bind:key="'field' + field.rowind + index + key">{{ field.name }}</th>
                  <th v-for="(field, index) in ratings.subFields" v-bind:key="'ratingsth' + field.title + index">
                    {{ field.name }}
                    <i class="fa fa-caret-down" v-if="(field.sort == 1 || field.sort == 0)"></i>
                    <i class="fa fa-caret-up" v-else-if="(field.sort == 2 || field.sort == 0)"></i>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="IN" v-for="(tr, ind) in whatsIn" v-bind:key="'trBod' + '-' + ind">
                  <td>
                    <span v-if="rawDataType == 'schemes'">
                      <span v-if="page > 1">{{ (perPage * (page - 1)) + (ind + 1) }}</span>
                      <span v-else>{{ ind + 1 }}</span>
                    </span>
                    <span v-else>{{ ind + 1 }}</span>
                  </td>
                  <td v-for="(cl, index) in tableFields" v-bind:key="index + 'cldata' + cl.title">
                    <span v-if="cl.isLink">
                      <!-- <a class="a-btn" @click.prevent="showSchemeHoldings(tr[cl.title])">{{tr[cl.title]}}</a> -->
                      <router-link class="a-btn" :to="'/mutual-funds/schemeholdings/' + tr[cl.title]" target="_blank">{{
                        tr[cl.title] }}</router-link>
                    </span>
                    <span v-else>
                      <span v-if="cl.datatype == 'date'">{{ (tr[cl.title]) ? getDate(tr[cl.title]) : '-' }}</span>
                      <span v-else-if="cl.datatype == 'numeric'">{{ getChecknFixed(tr[cl.title]) }}</span>
                      <span v-else>{{ (tr[cl.title]) ? (tr[cl.title]) : '-' }}</span>
                    </span>
                  </td>
                </tr>
                <tr v-if="whatsIn.length == 0">
                  <td :colspan="tableFields.length + 1">
                    <div class="alert alert-danger">No data Found!</div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="row">
              <div class="col-md-12">
                <h3>Whats Out</h3>
              </div>
            </div>
            <table :id="'mf' + rawDataType" class="table table-bordered fonts11 app-inner">
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th class="data-cell" v-for="(field, index, key) in tableFields"
                    v-bind:key="'field' + field.rowind + index + key">{{ field.name }}</th>
                  <th v-for="(field, index) in ratings.subFields" v-bind:key="'ratingsth' + field.title + index">
                    {{ field.name }}
                    <i class="fa fa-caret-down" v-if="(field.sort == 1 || field.sort == 0)"></i>
                    <i class="fa fa-caret-up" v-else-if="(field.sort == 2 || field.sort == 0)"></i>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="IN" v-for="(tr, ind) in whatsOut" v-bind:key="'trBod' + '-' + ind">
                  <td>
                    <span v-if="rawDataType == 'schemes'">
                      <span v-if="page > 1">{{ (perPage * (page - 1)) + (ind + 1) }}</span>
                      <span v-else>{{ ind + 1 }}</span>
                    </span>
                    <span v-else>{{ ind + 1 }}</span>
                  </td>
                  <td v-for="(cl, index) in tableFields" v-bind:key="index + 'cldata' + cl.title">
                    <span v-if="cl.isLink">
                      <!-- <a class="a-btn" @click.prevent="showSchemeHoldings(tr[cl.title])">{{tr[cl.title]}}</a> -->
                      <router-link class="a-btn" :to="'/mutual-funds/schemeholdings/' + tr[cl.title]" target="_blank">{{
                        tr[cl.title] }}</router-link>
                    </span>
                    <span v-else>
                      <span v-if="cl.datatype == 'date'">{{ (tr[cl.title]) ? getDate(tr[cl.title]) : '-' }}</span>
                      <span v-else-if="cl.datatype == 'numeric'">{{ getChecknFixed(tr[cl.title]) }}</span>
                      <span v-else>{{ (tr[cl.title]) ? (tr[cl.title]) : '-' }}</span>
                    </span>
                  </td>
                </tr>
                <tr v-if="whatsOut.length == 0">
                  <td :colspan="tableFields.length + 1">
                    <div class="alert alert-danger">No data Found!</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-responsive scrollbar app mb5" v-dragscroll="true"
            v-else-if="schemeReturnRankCols.length && rawDataType === 'scheme-return-ranks'">
            <table class="table table-bordered fonts11 app-inner" :id="'mf' + rawDataType">
              <tbody v-for="(data, ind) in schemeReturnRanks" v-bind:key="'tbody' + ind">
                <tr v-if="ind === 0">
                  <!-- <th>{{data.schemeName}}</th> -->
                  <th style="padding: 10px 80px;">Duration</th>
                  <th v-for="(th, ind1) in schemeReturnRankCols" v-bind:key="'thr' + '-' + ind1" colspan="3">{{ th.title
                  }}
                  </th>
                </tr>
                <tr v-if="ind === 0">
                  <th>Date</th>
                  <template v-for="(th, ind1) in schemeReturnRankCols">
                    <th v-bind:key="'rankTH' + '-' + ind1">
                      {{ 'Rank' }}
                    </th>
                    <th v-bind:key="'totalTH' + '-' + ind1">
                      {{ 'Total' }}
                    </th>
                    <th v-bind:key="'valueTH' + '-' + ind1">
                      {{ 'Value' }}
                    </th>
                  </template>
                </tr>
                <tr>
                  <td class="text-bold">{{ data.Date }} </td>
                  <template v-for="(td, ind1) in schemeReturnRankCols">
                    <td v-bind:key="'trdRank' + '-' + ind1">
                      <span>{{ data[td.title]['RANK'] }}</span>
                    </td>
                    <td v-bind:key="'trdTotal' + '-' + ind1">
                      <!-- <span>{{ schemeReturnRankTotals[ind][td.title]['total']['TOTAL'] }}</span> -->
                      <span>{{ data[td.title]['TOTAL'] }}</span>
                    </td>
                    <td v-bind:key="'trdValue' + '-' + ind1">
                      <span>{{ getFixed(data[td.title]['VALUE']) }}</span>
                    </td>
                  </template>
                </tr>
                <!-- <tr>
                    <td class="text-bold">Total</td>
                    <td class="text-bold" v-for="(td, ind1) in schemeReturnRankCols" v-bind:key="'trd'+'-'+ind1">
                     {{td.total.TOTAL}}
                    </td>
                  </tr> -->
              </tbody>
            </table>
          </div>
          <div class="table-responsive scrollbar app mb5" v-dragscroll="true"
            v-else-if="rawDataType == 'scheme-returns'">
            <table :id="'mf' + rawDataType" v-for="(data, ind) in rawData" v-bind:key="'table' + '-' + ind"
              class="table table-bordered fonts11 app-inner">
              <thead>
                <tr v-if="selScheme && selScheme != null" style="visibility:hidden">
                  <th :colspan="schemeReturnsFields.length + 1">
                    {{ selScheme.name }}
                  </th>
                </tr>
                <tr>
                  <td>{{ 'DATE' }}</td>
                  <td colspan="8" class="text-bold">{{ getDate(data['DATE']) }}</td>
                </tr>
              </thead>
              <thead>
                <tr>
                  <th>{{ 'Category' }}</th>
                  <th class="data-cell" v-for="(field, index, key) in schemeReturnsFields"
                    v-bind:key="'field' + field.rowind + index + key">
                    {{ field.name }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(tr, ind1) in schemeReturnsRows" v-bind:key="'trBod' + '-' + ind1">
                  <td> {{ tr.name }} <br />{{ (tr.title == 'BM') ? '(' + data.BenchmarkName + ')' : '' }}</td>
                  <td v-for="(cl, index, key) in schemeReturnsFields" v-bind:key="'data' + cl.rowind + index + key"
                    class="text-bold">
                    <span v-if="ind1 == 0">
                      <span v-if="cl.datatype == 'date'">{{ (data[cl.title]) ? getDate(data[cl.title]) : '-' }}</span>
                      <span v-else-if="cl.datatype == 'numeric'"
                        :class="(data[cl.title] < 0) ? 'error' : (data[cl.title] >= 0) ? 'success' : ''">{{
                          (data[cl.title]
                            !==
                            null) ? getFixed2dec(data[cl.title]) + '%' : '-' }}</span>
                      <span v-else>{{ (data[cl.title]) ? (data[cl.title]) : '-' }}</span>
                    </span>
                    <span v-if="ind1 == 1">
                      <span>
                        <span v-if="cl.datatype == 'date'">{{ (data[tr.title + cl.bsubtitle]) ?
                          getDate(data[tr.title + cl.bsubtitle]) :
                          '-' }}</span>
                        <span v-else-if="cl.datatype == 'numeric'"
                          :class="(data[tr.title + cl.bsubtitle] < 0) ? 'error' : (data[tr.title + cl.bsubtitle] >= 0) ? 'success' : ''">{{
                            (data[tr.title + cl.bsubtitle]
                              !== null && data[tr.title + cl.bsubtitle] !== undefined) ?
                              getFixed2dec(data[tr.title + cl.bsubtitle]) + '%'
                              : '-' }}</span>
                        <span v-else>{{ (data[tr.title + cl.bsubtitle]) ? (data[tr.title + cl.bsubtitle]) + '%' : '-'
                        }}</span>
                      </span>
                    </span>
                    <span v-if="ind1 > 1">
                      <!-- {{cl.subtitle+tr.title + '=' + cl.schname +'=='+tr.subtitle}} -->
                      <span v-if="cl.title == '6MONTH' && tr.title == 'MIN'">
                        <span v-if="cl.datatype == 'date'">{{ (data['6' + tr.title]) ? getDate(data['6' + tr.title]) :
                          '-' }}</span>
                        <span v-else-if="cl.datatype == 'numeric'"
                          :class="(data['6' + tr.title] < 0) ? 'error' : (data['6' + tr.title] >= 0) ? 'success' : ''">{{
                            (data['6' + tr.title]
                              !== null && data['6' + tr.title] !== undefined) ? getFixed2dec(data['6' + tr.title]) :
                              '-' }}</span>
                        <span v-else>{{ (data['6' + tr.title]) ? (data['6' + tr.title]) : '-' }}</span>
                        <span style="display: flex; font-weight: 600;" v-if="tr.subtitle != ''">({{ data['6' +
                          tr.subtitle]
                        }})</span>
                      </span>
                      <span v-else>
                        <span v-if="cl.datatype == 'date'">{{ (data[cl.subtitle + tr.title]) ?
                          getDate(data[cl.subtitle + tr.title]) :
                          '-' }}</span>
                        <span v-else-if="cl.datatype == 'numeric'"
                          :class="(data[cl.subtitle + tr.title] < 0) ? 'error' : (data[cl.subtitle + tr.title] >= 0) ? 'success' : ''">{{
                            (data[cl.subtitle + tr.title] !== null && data[cl.subtitle + tr.title] !== undefined) ?
                              getFixed2dec(data[cl.subtitle + tr.title]) + '%' : '-' }}</span>
                        <span v-else>{{ (data[cl.subtitle + tr.title]) ? (data[cl.subtitle + tr.title]) : '-' }}</span>
                        <span style="display: flex; font-weight: 600;" v-if="tr.subtitle != ''">({{ data[cl.schname +
                          tr.subtitle]
                        }})</span>
                      </span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="row mb5" v-if="!rawData.length && rawDataType == 'scheme-returns'">
              <div class="col-md-12">
                <div class="alert alert-danger" role="alert">No data found!</div>
              </div>
            </div>
            <!----- SCHEME RETURN RANKS TAB ---->
            <!-- <div class="row mt10">
                <div class="col-md-10"></div>
                <div class="col-md-2">
                  <download :tableId="'mf-ranks'+rawDataType" :fileName="rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
                </div>
                <div class="col-md-12">
                  <table :id="'mf-ranks'+rawDataType" class="table table-bordered fonts11 app-inner">
                    <thead>
                      <tr>
                        <th>{{schemeReturnRankDate}}</th>
                        <th v-for="(th, ind1) in schemeReturnRanks" v-bind:key="'thr'+'-'+ind1">{{th.title}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(tr, ind) in schemeReturnRankRows" v-bind:key="'tr-'+ind">
                        <td class="text-bold">{{tr.name}}</td>
                        <td v-for="(td, ind1) in schemeReturnRanks" v-bind:key="'trd'+'-'+ind1">
                          <span v-if="tr.dataType == 'numeric'">
                            <span v-if="tr.title == 'TOTAL'">{{(td.total)}}</span>
                            <span v-else>{{getFixed(td.data[tr.title])}}</span>
                          </span>
                          <span v-else>
                            <span v-if="tr.title == 'TOTAL'">{{(td.total[tr.title])}}</span>
                            <span v-else>{{(td.data[tr.title])}}</span>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div> -->
          </div>
          <div class="row" v-if="rawDataList[selRowInd].isPaginate">
            <div class="col-md-7"></div>
            <div class="col-md-5">
              <div class="pull-right">
                <ul v-if="totalPages != 1" class="pagination">
                  <li :class="{ disabled: prevDisabled }" class="page-item">
                    <a class="page-link" @click.prevent="goToPage(1)" href="#">&lt;&lt;</a>
                  </li>
                  <li :class="{ disabled: prevDisabled }" class="page-item">
                    <a class="page-link" @click.prevent="prev()" href="#">&lt;</a>
                  </li>
                  <li v-for="page in pages" v-bind:key="page" class="page-item"
                    :class="(current_page == page) ? 'active' : ''">
                    <a class="page-link" @click.prevent="goToPage(page)" href="#">{{ page }}</a>
                  </li>
                  <li :class="{ disabled: nextDisabled }" class="page-item">
                    <a class="page-link" href="#" @click.prevent="next()">&gt;</a>
                  </li>
                  <li :class="{ disabled: nextDisabled }" class="page-item">
                    <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">&gt;&gt;</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!--- ANAlysis SUM ratings ---->
          <div class="row mb5 mt10" v-if="rawDataType === 'analysis-sum' || rawDataType === 'analysis-sum-latest'">
            <div class="col-md-4" v-if="rawData && (rawData['q1_a_greater'] || rawData['q1_b_greater'])">
              <div class="row">
                <div class="col-md-9">
                  <h3>Growth Vs. Value</h3>
                </div>
                <div class="col-md-3">
                  <download :tableId="'qab-' + rawDataType"
                    :fileName="'qab' + rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')"></download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'qab-' + rawDataType">
                <tbody>
                  <tr>
                    <td class="text-bold">Q1 A Greater</td>
                    <td>
                      <span>
                        {{ getFixed(valueVsGrowthTotal.value) }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-bold">Q1 B Greater</td>
                    <td>
                      <span>
                        {{ getFixed(valueVsGrowthTotal.growth) }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-bold">Total</td>
                    <td class="text-bold">{{ getFixed(valueVsGrowthTotal.total) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-8" v-if="rawData && valueGrowthData.length > 0">
              <div class="row">
                <div class="col-md-9">
                  <h3>Growth Vs. Value</h3>
                </div>
                <div class="col-md-3">
                  <download :tableId="'q1a' + rawDataType"
                    :fileName="'q1a' + rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')"></download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'q1a' + rawDataType">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Value</th>
                    <th>Growth</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, ind) in valueGrowthData" v-bind:key="'q1a' + ind">
                    <td>{{ item.title }}</td>
                    <td>{{ item.value ? getFixed(item.value) + "%" : '-' }}<br />{{ item.noofstocksv }}</td>
                    <td>{{ item.growth ? getFixed(item.growth) + "%" : '-' }}<br />{{ item.noofstocksg }}</td>
                    <td>{{ item.sum ? getFixed(item.sum) + "%" : '-' }}<br />{{ item.noofstocksmcap }}</td>
                  </tr>
                  <tr>
                    <td class="text-bold">Total</td>
                    <td class="text-bold">
                      {{ getFixed(valueVsGrowthTotal.value) + "%" }}<br />{{ valueVsGrowthTotal.noofstocksv }}</td>
                    <td class="text-bold">
                      {{ getFixed(valueVsGrowthTotal.growth) + "%" }}<br />{{ valueVsGrowthTotal.noofstocksg }}</td>
                    <td class="text-bold">
                      {{ getFixed(valueVsGrowthTotal.total) + "%" }}<br />{{ valueVsGrowthTotal.noofstocks }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-12"
              v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.credit_ratings">
              <div class="row">
                <div class="col-md-9">
                  <h3>Typewise Ratings</h3>
                </div>
                <div class="col-md-3">
                  <download :tableId="'cr-' + rawDataType"
                    :fileName="'cr' + rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')"></download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'cr-' + rawDataType">
                <thead>
                  <tr>
                    <th v-for="(cr, ind) in creditRatingsKeys" v-bind:key="'crth' + ind">{{ cr.name }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(crData, ind) in rawData.holdings_summary.credit_ratings" v-bind:key="'crtr' + ind">
                    <td v-for="(cr, ind) in creditRatingsKeys" v-bind:key="'crtd' + ind">
                      <span v-if="cr.datatype == 'numeric'">
                        {{ (crData[cr.title]) ? getFixed(crData[cr.title]) : '' }}
                      </span>
                      <span v-else>{{ crData[cr.title] }}</span>
                    </td>
                  </tr>
                  <tr>
                    <!-- <td > <b> {{ getFixed(getPercentHoldingTotal)  }} </b>  </td> -->
                    <td v-for="(cr, tdInd) in creditRatingsKeys" :key="tdInd + 'crtotal'">
                      <span v-if="cr.title == 'name'"><b>Total</b></span>
                      <span v-else-if="cr.title == 'type'"><b></b></span>
                      <span v-else-if="cr.title != 'type' && cr.title != 'name'"><b> {{
                        getFixed(rawData.holdings_summary['totals']['credit_ratings'][cr.title]) }} </b></span>
                      <span v-else>-</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6"
              v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.top_3_exposures">
              <div class="row">
                <div class="col-md-9">
                  <h3>Top 3 Exposures</h3>
                </div>
                <div class="col-md-3">
                  <download :tableId="'exp' + rawDataType"
                    :fileName="'exp-' + rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')"></download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'exp' + rawDataType">
                <thead>
                  <tr>
                    <th>Sectors</th>
                    <th>% Holding</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(exp, ind) in top3exposuresKeys" v-bind:key="'exp' + ind">
                    <td>{{ exp }}</td>
                    <td>{{ (rawData.holdings_summary['top_3_exposures'] &&
                      rawData.holdings_summary['top_3_exposures'][exp]) ?
                      getFixed(rawData.holdings_summary['top_3_exposures'][exp]) : '' }}</td>
                  </tr>
                  <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                    <td class="text-bold">Total</td>
                    <td class="text-bold">{{ getFixed(rawData.holdings_summary.totals['top_3_exposures']) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--- TOP 3 ---->
            <div class="col-md-6"
              v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.top_3_industrywise">
              <div class="row">
                <div class="col-md-9">
                  <h3>Top 3 Industry Holdings</h3>
                </div>
                <div class="col-md-3">
                  <download :tableId="'ind' + rawDataType"
                    :fileName="'ind-' + rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')"></download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'ind' + rawDataType">
                <thead>
                  <tr>
                    <th>Industry</th>
                    <th>% Holding</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(tind, ind) in top3industryKeys" v-bind:key="'tind' + ind">
                    <td>{{ tind }}</td>
                    <td>{{ (rawData.holdings_summary['top_3_industrywise'] &&
                      rawData.holdings_summary['top_3_industrywise'][tind]) ?
                      getFixed(rawData.holdings_summary['top_3_industrywise'][tind]) : '' }}</td>
                  </tr>
                  <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                    <td class="text-bold">Total</td>
                    <td class="text-bold">{{ getFixed(rawData.holdings_summary.totals['top_3_industrywise']) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.psumratingwise">
              <div class="row">
                <div class="col-md-11">
                  <h3>Business Ratingwise Holdings</h3>
                </div>
                <div class="col-md-1">
                  <download :tableId="'br' + rawDataType"
                    :fileName="'br-' + rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')"></download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'br' + rawDataType">
                <thead>
                  <tr>
                    <th>Business Ratings</th>
                    <th>% Holding</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(brate, ind) in businessRatingKeys" v-bind:key="'type' + ind">
                    <td>
                      <star-rating v-bind:increment="0.5" v-bind:max-rating="7" :rating="parseInt(brate)"
                        :read-only="true" :show-rating="false" inactive-color="#868e96" active-color="#ffbf00"
                        v-bind:star-size="20"></star-rating>
                    </td>
                    <td>{{ (rawData.holdings_summary['psumratingwise'] &&
                      rawData.holdings_summary['psumratingwise']['business_rating'] &&
                      rawData.holdings_summary['psumratingwise']['business_rating'][brate]) ?
                      getFixed(rawData.holdings_summary['psumratingwise']['business_rating'][brate]) : 'NA' }}</td>
                  </tr>
                  <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                    <td class="text-bold">Total</td>
                    <td class="text-bold">
                      {{ getFixed(rawData.holdings_summary.totals['psumratingwise']['business_rating']) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.psumratingwise">
              <div class="row">
                <div class="col-md-9">
                  <h3>Debt Ratingwise Holdings</h3>
                </div>
                <div class="col-md-3">
                  <download :tableId="'debt' + rawDataType"
                    :fileName="'debt-' + rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')"></download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'debt' + rawDataType">
                <thead>
                  <tr>
                    <th>Debt Rating</th>
                    <th>% Holding</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(qrate, ind) in debtRatingKeys" v-bind:key="'type' + ind">
                    <td><star-rating v-bind:increment="0.5" v-bind:max-rating="7" :rating="parseInt(qrate)"
                        :read-only="true" :show-rating="false" inactive-color="#868e96" active-color="#ffbf00"
                        v-bind:star-size="20"></star-rating>
                    </td>
                    <td>{{ (rawData.holdings_summary['psumratingwise'] &&
                      rawData.holdings_summary['psumratingwise']['debt_rating']
                      && rawData.holdings_summary['psumratingwise']['debt_rating'][qrate]) ?
                      getFixed(rawData.holdings_summary['psumratingwise']['debt_rating'][qrate]) : 'NA' }}</td>
                  </tr>
                  <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                    <td class="text-bold">Total</td>
                    <td class="text-bold">{{ getFixed(rawData.holdings_summary.totals['psumratingwise']['debt_rating'])
                    }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.psumratingwise">
              <div class="row">
                <div class="col-md-9">
                  <h3>Valuation Ratingwise Holdings</h3>
                </div>
                <div class="col-md-3">
                  <download :tableId="'vr' + rawDataType"
                    :fileName="'vr-' + rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')"></download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'vr' + rawDataType">
                <thead>
                  <tr>
                    <th>Valuation Ratings</th>
                    <th>% Holding</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(vrate, ind) in valuationRatingKeys" v-bind:key="'type' + ind">
                    <td>
                      <star-rating v-bind:increment="0.5" v-bind:max-rating="5" :rating="parseInt(vrate)"
                        :read-only="true" :show-rating="false" inactive-color="#868e96" active-color="#ffbf00"
                        v-bind:star-size="20"></star-rating>
                    </td>
                    <td>{{ (rawData.holdings_summary['psumratingwise'] &&
                      rawData.holdings_summary['psumratingwise']['valuation_rating'] &&
                      rawData.holdings_summary['psumratingwise']['valuation_rating'][vrate]) ?
                      getFixed(rawData.holdings_summary['psumratingwise']['valuation_rating'][vrate]) : 'NA' }}</td>
                  </tr>
                  <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                    <td class="text-bold">Total</td>
                    <td class="text-bold">
                      {{ getFixed(rawData.holdings_summary.totals['psumratingwise']['valuation_rating']) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.psumratingwise">
              <div class="row">
                <div class="col-md-9">
                  <h3>Quarterly Ratingwise Holdings</h3>
                </div>
                <div class="col-md-3">
                  <download :tableId="'qr' + rawDataType"
                    :fileName="'qr-' + rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')"></download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'qr' + rawDataType">
                <thead>
                  <tr>
                    <th>Quarterly Rating</th>
                    <th>% Holding</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(qrate, ind) in qtrRatingKeys" v-bind:key="'type' + ind">
                    <td><star-rating v-bind:increment="0.5" v-bind:max-rating="5" :rating="parseInt(qrate)"
                        :read-only="true" :show-rating="false" inactive-color="#868e96" active-color="#ffbf00"
                        v-bind:star-size="20"></star-rating>
                    </td>
                    <td>{{ (rawData.holdings_summary['psumratingwise'] &&
                      rawData.holdings_summary['psumratingwise']['quarterly_rating'] &&
                      rawData.holdings_summary['psumratingwise']['quarterly_rating'][qrate]) ?
                      getFixed(rawData.holdings_summary['psumratingwise']['quarterly_rating'][qrate]) : 'NA' }}</td>
                  </tr>
                  <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                    <td class="text-bold">Total</td>
                    <td class="text-bold">
                      {{ getFixed(rawData.holdings_summary.totals['psumratingwise']['quarterly_rating']) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6"
              v-if="rawData && rawData.frontend_data && rawData.frontend_data.raw && rawData.frontend_data.number">
              <div class="row">
                <div class="col-md-9">
                  <h3>Overall Ratings</h3>
                </div>
                <div class="col-md-3">
                  <download :tableId="'overallrating' + rawDataType"
                    :fileName="'overallrating-' + rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')">
                  </download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'overallrating' + rawDataType">
                <thead>
                  <tr>
                    <th></th>
                    <th>Rating</th>
                    <th>Star</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(overallRate, orInd) in overallRatingKeys" :key="orInd + 'overall'">
                    <td>{{ overallRate.name }}</td>
                    <td>{{ (rawData.frontend_data.raw[overallRate.title]) ?
                      getFixed(rawData.frontend_data.raw[overallRate.title]) :
                      '' }}</td>
                    <td>
                      <span>
                        <star-rating v-bind:increment="0.5"
                          v-bind:max-rating="(overallRate.title == 'overall_business_rating' || overallRate.title == 'overall_debt_others_rating' || overallRate.title == 'overall_equity_rating') ? 7 : 5"
                          :rating="parseInt(rawData.frontend_data.number[overallRate.title])" :read-only="true"
                          :show-rating="false" inactive-color="#868e96" active-color="#ffbf00"
                          v-bind:star-size="20"></star-rating>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.mcaptypewise">
              <div class="row">
                <div class="col-md-9">
                  <h3>MCapwise Holdings</h3>
                </div>
                <div class="col-md-3">
                  <download :tableId="'mcap' + rawDataType"
                    :fileName="'mcap-' + rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')"></download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'mcap' + rawDataType">
                <thead>
                  <tr>
                    <th>MCapwise</th>
                    <th>% Holding</th>
                    <th>Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(mcap, ind) in mcapKeys" v-bind:key="'mcap' + ind">
                    <td>{{ mcap }}</td>
                    <td>{{ (rawData.holdings_summary['mcaptypewise'] &&
                      rawData.holdings_summary['mcaptypewisenew']['PERC_HOLD'][mcap]) ?
                      getFixed(rawData.holdings_summary['mcaptypewisenew']['PERC_HOLD'][mcap]) : '' }}</td>
                    <td>{{ (rawData.holdings_summary['mcaptypewise'] &&
                      rawData.holdings_summary['mcaptypewisenew']['number'][mcap]) ?
                      (rawData.holdings_summary['mcaptypewisenew']['number'][mcap]) : '' }}</td>
                  </tr>
                  <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                    <td class="text-bold">Total</td>
                    <td class="text-bold">{{ getFixed(rawData.holdings_summary.totals['mcaptypewise']) }}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.ratings_equity">
              <div class="row">
                <div class="col-md-11">
                  <h3>Business Ratingwise Holdings (Equity)</h3>
                </div>
                <div class="col-md-1">
                  <download :tableId="'br-e' + rawDataType"
                    :fileName="'br-Eq' + rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')"></download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'br-e' + rawDataType">
                <thead>
                  <tr>
                    <th>Business Ratings</th>
                    <th>% Holding</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(brate, ind) in businessRatingKeys" v-bind:key="'type' + ind">
                    <td>
                      <star-rating v-bind:increment="0.5" v-bind:max-rating="7" :rating="parseInt(brate)"
                        :read-only="true" :show-rating="false" inactive-color="#868e96" active-color="#ffbf00"
                        v-bind:star-size="20"></star-rating>
                    </td>
                    <td>{{ (rawData.holdings_summary['ratings_equity'] &&
                      rawData.holdings_summary['ratings_equity']['business_rating'] &&
                      rawData.holdings_summary['ratings_equity']['business_rating'][brate]) ?
                      getFixed(rawData.holdings_summary['ratings_equity']['business_rating'][brate]) : 'NA' }}</td>
                  </tr>
                  <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                    <td class="text-bold">Total</td>
                    <td class="text-bold">
                      {{ getFixed(rawData.holdings_summary.totals['ratings_equity']['business_rating']) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.ratings_equity">
              <div class="row">
                <div class="col-md-9">
                  <h3>Debt Ratingwise Holdings (Equity)</h3>
                </div>
                <div class="col-md-3">
                  <download :tableId="'debt-e' + rawDataType"
                    :fileName="'debt-Eq' + rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')"></download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'debt-e' + rawDataType">
                <thead>
                  <tr>
                    <th>Debt Rating</th>
                    <th>% Holding</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(qrate, ind) in debtRatingKeys" v-bind:key="'type' + ind">
                    <td><star-rating v-bind:increment="0.5" v-bind:max-rating="7" :rating="parseInt(qrate)"
                        :read-only="true" :show-rating="false" inactive-color="#868e96" active-color="#ffbf00"
                        v-bind:star-size="20"></star-rating>
                    </td>
                    <td>{{ (rawData.holdings_summary['ratings_equity'] &&
                      rawData.holdings_summary['ratings_equity']['debt_rating']
                      && rawData.holdings_summary['ratings_equity']['debt_rating'][qrate]) ?
                      getFixed(rawData.holdings_summary['ratings_equity']['debt_rating'][qrate]) : 'NA' }}</td>
                  </tr>
                  <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                    <td class="text-bold">Total</td>
                    <td class="text-bold">{{ getFixed(rawData.holdings_summary.totals['ratings_equity']['debt_rating'])
                    }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.ratings_equity">
              <div class="row">
                <div class="col-md-9">
                  <h3>Valuation Ratingwise Holdings (Equity)</h3>
                </div>
                <div class="col-md-3">
                  <download :tableId="'vr-e' + rawDataType"
                    :fileName="'vr-Eq' + rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')"></download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'vr-e' + rawDataType">
                <thead>
                  <tr>
                    <th>Valuation Ratings</th>
                    <th>% Holding</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(vrate, ind) in valuationRatingKeys" v-bind:key="'type' + ind">
                    <td>
                      <star-rating v-bind:increment="0.5" v-bind:max-rating="5" :rating="parseInt(vrate)"
                        :read-only="true" :show-rating="false" inactive-color="#868e96" active-color="#ffbf00"
                        v-bind:star-size="20"></star-rating>
                    </td>
                    <td>{{ (rawData.holdings_summary['ratings_equity'] &&
                      rawData.holdings_summary['ratings_equity']['valuation_rating'] &&
                      rawData.holdings_summary['ratings_equity']['valuation_rating'][vrate]) ?
                      getFixed(rawData.holdings_summary['ratings_equity']['valuation_rating'][vrate]) : 'NA' }}</td>
                  </tr>
                  <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                    <td class="text-bold">Total</td>
                    <td class="text-bold">
                      {{ getFixed(rawData.holdings_summary.totals['ratings_equity']['valuation_rating']) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.ratings_equity">
              <div class="row">
                <div class="col-md-9">
                  <h3>Quarterly Ratingwise Holdings (Equity)</h3>
                </div>
                <div class="col-md-3">
                  <download :tableId="'qr-e' + rawDataType"
                    :fileName="'qr-Eq' + rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')"></download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'qr-e' + rawDataType">
                <thead>
                  <tr>
                    <th>Quarterly Rating</th>
                    <th>% Holding</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(qrate, ind) in qtrRatingKeys" v-bind:key="'type' + ind">
                    <td><star-rating v-bind:increment="0.5" v-bind:max-rating="5" :rating="parseInt(qrate)"
                        :read-only="true" :show-rating="false" inactive-color="#868e96" active-color="#ffbf00"
                        v-bind:star-size="20"></star-rating>
                    </td>
                    <td>{{ (rawData.holdings_summary['ratings_equity'] &&
                      rawData.holdings_summary['ratings_equity']['quarterly_rating'] &&
                      rawData.holdings_summary['ratings_equity']['quarterly_rating'][qrate]) ?
                      getFixed(rawData.holdings_summary['ratings_equity']['quarterly_rating'][qrate]) : 'NA' }}</td>
                  </tr>
                  <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                    <td class="text-bold">Total</td>
                    <td class="text-bold">
                      {{ getFixed(rawData.holdings_summary.totals['ratings_equity']['quarterly_rating']) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6"
              v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.ratings_equity && rawData.holdings_summary.ratings_equity.mcaptypewise">
              <div class="row">
                <div class="col-md-9">
                  <h3>MCapwise Holdings (Equity)</h3>
                </div>
                <div class="col-md-3">
                  <download :tableId="'mcap-e-' + rawDataType"
                    :fileName="'mcap-Eq' + rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')"></download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'mcap-e-' + rawDataType">
                <thead>
                  <tr>
                    <th>MCapwise</th>
                    <th>% Holding</th>
                    <th>Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(mcap, ind) in mcapKeys" v-bind:key="'mcap' + ind">
                    <td>{{ mcap }}</td>
                    <td>{{ (rawData.holdings_summary.ratings_equity['mcaptypewise'] &&
                      rawData.holdings_summary.ratings_equity['mcaptypewise']['PERC_HOLD'][mcap]) ?
                      getFixed(rawData.holdings_summary.ratings_equity['mcaptypewise']['PERC_HOLD'][mcap]) : '' }}</td>
                    <td>{{ (rawData.holdings_summary.ratings_equity['mcaptypewise'] &&
                      rawData.holdings_summary.ratings_equity['mcaptypewise']['number'][mcap]) ?
                      (rawData.holdings_summary.ratings_equity['mcaptypewise']['number'][mcap]) : '' }}</td>
                  </tr>
                  <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                    <td class="text-bold">Total</td>
                    <td class="text-bold">
                      {{ getFixed(rawData.holdings_summary.totals.ratings_equity['mcaptypewise']['PERC_HOLD']) }}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.typewise">
              <div class="row">
                <div class="col-md-9">
                  <h3>Typewise Holdings</h3>
                </div>
                <div class="col-md-3">
                  <download :tableId="'type' + rawDataType"
                    :fileName="'type-' + rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')"></download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'type' + rawDataType">
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>% Holding</th>
                    <th>Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(sector, secInd) in rawData.holdings_summary.typewise" v-bind:key="'tr-sector' + secInd">
                    <td v-for="(industry, ind) in typewiseKeys" v-bind:key="'td-sector' + ind">{{ sector[industry.title]
                    }}
                    </td>
                  </tr>
                  <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                    <td class="text-bold">Total</td>
                    <td class="text-bold">{{ getFixed(rawData.holdings_summary.totals['typewise']) }}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-12"
              v-if="rawData && rawData.frontend_data && rawData.frontend_data.schemes_under_fof && rawData.frontend_data.schemes_under_fof.length">
              <div class="row">
                <div class="col-md-9">
                  <h3>FoFs Overall Ratings</h3>
                </div>
                <div class="col-md-3">
                  <download :tableId="'overallrating' + rawDataType"
                    :fileName="'overallrating-' + rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')">
                  </download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'schemeFofooverallrating' + rawDataType">
                <thead>
                  <tr>
                    <th>Scheme Name</th>
                    <th>% Holding</th>
                    <th v-for="(overallRate, orInd) in overallRatingKeys" :key="orInd + 'overall'">{{ overallRate.name
                    }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(schemeData, schInd) in rawData.frontend_data.schemes_under_fof"
                    :key="schInd + 'schemefofOverall'">
                    <td>{{ schemeData.sch_name }}</td>
                    <td>{{ schemeData['PERC_HOLD'] }}</td>
                    <td v-for="(overallRate, orInd) in overallRatingKeys" :key="orInd + 'overall'">
                      {{ (schemeData.frontend_data.raw[overallRate.title]) ?
                        getFixed(schemeData.frontend_data.raw[overallRate.title]) : '' }}</td>
                  </tr>
                  <tr>
                    <td class="text-bold">Total</td>
                    <td>{{ (rawData['PERC_HOLD']) ? getFixed(rawData['PERC_HOLD']) : '' }}</td>
                    <td v-for="(overallRate, orInd) in overallRatingKeys" :key="orInd + 'overall'">
                      {{ (rawData.frontend_data.raw[overallRate.title]) ?
                        getFixed(rawData.frontend_data.raw[overallRate.title]) :
                        '' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.ratingwise">
              <div class="row">
                <div class="col-md-9">
                  <h3>Ratingwise Holdings</h3>
                </div>
                <div class="col-md-3">
                  <download :tableId="'rating' + rawDataType"
                    :fileName="'rating-' + rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')"></download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'rating' + rawDataType">
                <thead>
                  <tr>
                    <th v-for="(rating, ind) in crRatingKeys" v-bind:key="'ratingth' + ind">{{ rating.name }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(industry, ind) in rawData.holdings_summary['ratingwise']" v-bind:key="'ratingt' + ind">
                    <td v-for="(rating, index) in crRatingKeys" v-bind:key="'ratingr' + index">
                      <span v-if="rating.datatype == 'numeric'">{{ (industry[rating.title]) ?
                        getFixed(industry[rating.title]) :
                        '' }}</span>
                      <span v-else>{{ (industry[rating.title]) ? (industry[rating.title]) : '' }}</span>
                    </td>
                  </tr>
                  <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                    <td class="text-bold">Total</td>
                    <td class="text-bold">{{ getFixed(rawData.holdings_summary.totals['ratingwise']) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6"
              v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.clubbed_ratings">
              <div class="row">
                <div class="col-md-9">
                  <h3>Mixed Ratingwise Holdings</h3>
                </div>
                <div class="col-md-3">
                  <download :tableId="'rating' + rawDataType"
                    :fileName="'rating-' + rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')"></download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'rating' + rawDataType">
                <thead>
                  <tr>
                    <th v-for="(rating, ind) in crRatingKeys" v-bind:key="'ratingth' + ind">{{ rating.name }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(industry, ind) in rawData.holdings_summary['clubbed_ratings']"
                    v-bind:key="'ratingt' + ind">
                    <td v-for="(rating, index) in crRatingKeys" v-bind:key="'ratingr' + index">
                      <span v-if="rating.datatype == 'numeric'">{{ (industry[rating.title]) ?
                        getFixed(industry[rating.title]) :
                        '' }}</span>
                      <span v-else>{{ (industry[rating.title]) ? (industry[rating.title]) : '' }}</span>
                    </td>
                  </tr>
                  <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                    <td class="text-bold">Total</td>
                    <td class="text-bold">{{ getFixed(rawData.holdings_summary.totals['clubbed_ratings']) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.industrywise">
              <div class="row">
                <div class="col-md-9">
                  <h3>Industrywise Holdings</h3>
                </div>
                <div class="col-md-3">
                  <download :tableId="'indu' + rawDataType"
                    :fileName="'industry-' + rawDataType + ((selScheme && selScheme.id) ? selScheme.id : '')">
                  </download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'indu' + rawDataType">
                <thead>
                  <tr>
                    <th v-for="(industry, ind) in industryKeys" v-bind:key="'industry' + ind">{{ industry.name }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(sector, secInd) in rawData.holdings_summary.industrywise"
                    v-bind:key="'tr-sector' + secInd">
                    <td v-for="(industry, ind) in industryKeys" v-bind:key="'td-sector' + ind">{{ sector[industry.title]
                    }}
                    </td>
                    <!-- <td>{{(rawData.holdings_summary['industrywise'] && rawData.holdings_summary['industrywise'][industry])? getFixed(rawData.holdings_summary['industrywise'][industry]): ''}}</td> -->
                  </tr>
                  <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                    <td class="text-bold">Total</td>
                    <td class="text-bold">{{ getFixed(rawData.holdings_summary.totals['industrywise']) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row mb5 mt10 table-responsive scrollbar" v-dragscroll="true"
            v-if="tableFields.length && rawDataType === 'sector-historical'">
            <table class="table table-bordered font11 app-inner" :id="'mf' + rawDataType">
              <thead>
                <tr>
                  <th v-for="(field, ind) in tableFields" v-bind:key="'ratingth' + ind">{{ field.title }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, ind) in rawData" v-bind:key="'ratingt' + ind">
                  <td v-for="(field, ci) in tableFields" v-bind:key="'sector' + ci">
                    <span v-if="field.data_type == 'date'"> {{ item[ci][field.key] ? getDate(item[ci][field.key]) : '-'
                    }}
                    </span>
                    <span v-else-if="field.data_type == 'numeric'">{{ getChecknFixed(item[ci][field.key]) }}</span>
                    <span v-else-if="field.data_type == 'perc'">
                      {{ item[ci][field.key] ? getFixed2dec(item[ci][field.key]) + '%' : '-' }}
                    </span>
                    <span v-else>
                      {{ item[ci][field.key] }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row mb5"
            v-if="!tableFields.length && rawDataType != 'scheme-rolling-returns' && rawDataType != 'scheme-returns' && rawDataType != 'scheme-return-ranks' && rawDataType != 'sector-historical'">
            <div class="col-md-12">
              <div class="alert alert-danger" role="alert">No data found!</div>
            </div>
          </div>
        </v-tab>
      </vue-tabs>
    </div>
  </div>
  <!-- </card> -->
</template>
<script>
import { VueTabs, VTab } from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.scss";
import StarRating from "vue-star-rating";
import Datepicker from "vuejs-datepicker";

import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { rawMixins } from "../../assets/mixins/rawMixins.js";
import { CIRCLE } from '../../components/progressbar/vue-progress/constants.js';
import spinner from "../../components/spinner";

export default {
  components: { VueTabs, VTab, StarRating, Datepicker, spinner },
  mixins: [commonMixins, rawMixins],
  created() {
    //console.log('===> here 1');
    if (!localStorage.getItem("schemeTab")) {
      this.rawDataType = this.rawDataList[this.selRowInd].id;
      // this.selSchemeTab = this.rawDataList[this.selRowInd].value;
      // localStorage.setItem("schemeTab", this.rawDataType);
      // localStorage.setItem("selSchemeTab", this.selSchemeTab);
      //   this.getRawData();
    } else {
      // this.rawDataType = localStorage.getItem("schemeTab");
      // this.selSchemeTab = localStorage.getItem("selSchemeTab");
    }
    this.getSchemesList();
    // this.getRawData();
    //console.log("Rawtype", this.rawDataType, this.selSchemeTab);
  },
  methods: {
    downLoadAll() {
      this.isDownload = 1;
      this.getRawData();
    },
    getFilerDate() {
      //console.log('this.rawDataType >>>', this.rawDataType, this.selScheme);
      let oriFilterURL = "mutual-funds/filter-date?";
      let filterURL = "";
      let self = this;
      if (this.rawDataType === 'analysis-sum') {
        filterURL = oriFilterURL + "collection_name=analysis-sum" + "&scheme_code=" + this.selScheme.id;
      } else if (this.rawDataType === 'analysis') {
        filterURL = oriFilterURL + "collection_name=analysis" + "&scheme_code=" + this.selScheme.id;
      }
      //console.log('################# ', filterURL,'#################');
      if (this.rawDataType === 'analysis-sum' || this.rawDataType === 'analysis') {
        http.get(
          filterURL,
          {},
          (error, response) => {
            //console.log("error", this.rawDataType, error);
            //console.log("Response Filter:", this.rawDataType, response);
            if (response && response.responseType == 'success') {
              self.durDateList = response.date.length > 0 ? response.date : [];
              self.durDateList.map((date, index) => {
                self.durDateList[index] = date.split('T')[0];
              });
            }
          });
      }
    },
    updateRunAnalysis() {
      //Sanjay
      //console.log('@@@@this.selScheme >>>', this.selScheme)
      http.get(`mutual-funds/runAnalysis/${this.selScheme.id}`, {}, function (error, response) {
        console.log('runAnalysis: ', response);
        if (response.status == 'success') {
          //console.log('Success');
        }
      });
    },
    getRawData() {
      //console.log('isApplied', this.isApiCalled, this.durDate, this.getYMDDate(this.durDate));
      if (!this.isApiCalled && this.selScheme != null) {
        this.isApiCalled = 1;
        if (this.rawDataType !== 'scheme-rolling-returns')
          this.rawData = [];
        this.whatsIn = [];
        this.whatsOut = [];
        this.tableFields = [];
        this.actions = [];
        this.totalPages = 1;
        let myself = this;
        let apiUrl = "";
        if (this.rawDataType === 'basic') {
          apiUrl = this.rawDataApi + 'mf-scheme-master/' + this.selScheme.id;
        } else {
          apiUrl = this.rawDataApi + this.rawDataType + '/' + this.selScheme.id;
        }
        //console.log('Paginate', this.rawDataList[this.selRowInd].isPaginate);
        if (this.rawDataList[this.selRowInd].isPaginate) {
          apiUrl = apiUrl + '?page=' + this.page;
          if (this.durDate != null) {
            apiUrl = apiUrl + '&date=' + this.getYMDDate(this.durDate);
          }
        } else {
          if (this.durDate != null && this.checkInArray(this.dateFilterTabs, this.rawDataType)) {
            apiUrl = apiUrl + '?date=' + this.getYMDDate(this.durDate);
          }
        }

        if (this.rawDataType == 'scheme-nav-latest') {
          if (this.scheme_name != '') {
            apiUrl = apiUrl + '&scheme_name=' + this.scheme_name;
          }
        }
        if (this.rawDataType == 'scheme-nav-historical') {
          if (this.scheme_name != '') {
            apiUrl = apiUrl + '&scheme_name=' + this.scheme_name;
          }
          if (this.isDownload === 1) {
            apiUrl = apiUrl + '&download=1';
          }
        }
        if (this.rawDataType == 'scheme-asset-allocation') {
          //console.log('GroupBy');
          if (this.durDate != null) { apiUrl = apiUrl + '&groupBy=1'; } else {
            apiUrl = apiUrl + '?groupBy=1';
          }
          if (this.isDownload === 1) {
            apiUrl = apiUrl + '&download=1';
          }
        }

        if (this.rawDataType == 'scheme-rolling-returns') {
          apiUrl = apiUrl + '?duration=' + this.selDuration;
          if (this.isDownload === 1) {
            apiUrl = apiUrl + '&download=1';
          }
        }

        //console.log('APIURL:', apiUrl);

        http.get(
          apiUrl,
          {},
          (error, response) => {
            //console.log("error", this.rawDataType, error);
            //console.log("Response", this.rawDataType, response);
            if (response && response.status == 'success') {
              this.last_updated_date = '';
              if ('last_updated_date' in response && response.last_updated_date) {
                this.last_updated_date = response.last_updated_date.split('T')[0];
              } else if (response.data.length && response.data[0] && response.data[0].DATE) {
                this.last_updated_date = response.data[0].DATE.split('T')[0];
              } else if (response.last_date_used_for_calc) {
                this.last_updated_date = response.last_date_used_for_calc.split('T')[0];
                this.latest_date_used_for_calc = response.latest_date_used_for_calc.split('T')[0];
              }
              const resultData = response.data;
              this.isloading = false;
              //console.log('TAB:::', this.rawDataType, (this.rawDataType == 'scheme-rolling-returns'));
              // this.SCH_Table_NAME = '';
              // if(resultData && Array.isArray(resultData) && resultData.length > 0) {
              //   if('SCH_NAME' in resultData[0]) {
              //     this.SCH_Table_NAME = resultData[0].SCH_NAME;
              //   }
              // }
              // console.log('SCH_Table_NAME ==>>>', this.SCH_Table_NAME);
              if (this.rawDataType == 'basic') {
                this.rawData = response.data !== undefined ? response.data : {};
                //this.durDateList = response.data !== undefined ? [response.data] : [];
                //console.log('<<<< response >>>>', this.rawData)
                //console.log('<<<< rawData >>>>', Object.keys(this.rawData).length)

                this.searchData = this.rawData;
                if (Object.keys(this.rawData).length > 0) {
                  /* this.basicTableRows.forEach((row) => {
                    if (this.rawData.hasOwnProperty(row.title)) {
                      this.tableFields.push({
                        title: row.title,
                        name: row.name,
                        rowind: 0,
                        isLink: row.isLink,
                        datatype: (row.title === 'navdate' || row.title === 'LaunchDate') ? 'date' : '',
                        sort_order: row.sort_order
                      });
                    }
                  }); */
                  const dataObj = this.rawData;

                  this.tableFields = this.basicTableRows.map((item) => {
                    return {
                      label: item.name,
                      value: dataObj[item.title] || '-'
                    };
                  });

                  //console.log('<<<< this.tableFields >>>>', this.tableFields)

                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                }
              } else if (this.rawDataType == 'scheme-holdings') {
                this.rawData = response.data.length > 0 ? response.data : [];
                //this.durDateList = response.date.length > 0 ? response.date.reverse() : [];
                this.durDateList = response.date.length > 0 ? response.date : [];
                this.schemeHoldingsPercHold = response.total_perc_hold;
                this.durDateList.map((date, index) => {
                  this.durDateList[index] = date.split('T')[0];
                });

                this.searchData = this.rawData;
                //console.log(this.rawData);
                if (response.data.length > 0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if (tf != '_id' && tf != 'MF_SCHCODE' && tf != 'Mf_SchCode' && tf != 'Mf_SchCode' && tf != 'SCH_NAME' && tf != 'sch_name' && tf != 'SCHEME_NAM') {
                      // /&& tf != 'CO_CODE' && tf != 'NO_SHARES'
                      this.tableFields.push({
                        title: tf,
                        name: this.getLabel(tf),
                        rowind: 0,
                        isLink: 0,
                        datatype: (tf == 'INVDATE') ? 'date' : '',
                        sort_order: (tf == 'mf_schname' || tf == 'mf_schname' || tf == 'SCH_NAME' || tf == 'sch_name') ? 2
                          : (tf == 'MF_SCHCODE') ? 2
                            : (tf == 'TYPE') ? 3
                              : (tf == 'TYPECODE') ? 4
                                : (tf == 'IIND_NAME') ? 6
                                  : (tf == 'INVDATE') ? 5
                                    : (tf == 'CO_CODE') ? 7
                                      : (tf == 'CO_NAME') ? 8
                                        : (tf == 'MKTVALUE') ? 9
                                          : (tf == 'NO_SHARES') ? 10
                                            : (tf == 'PERC_HOLD') ? 11
                                              : 99
                      });
                    }
                  });
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                }
              } else if (this.rawDataType == 'scheme-ratios') {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                //console.log(this.rawData);
                if (response.data.length > 0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if (tf != '_id' && tf != 'mf_schcode' && tf != 'mf_schname' && tf != 'MF_SCHCODE' && tf != 'Mf_SchCode' && tf != 'Mf_SchCode' && tf != 'Mf_SchCode' && tf != 'SCH_NAME' && tf != 'sch_name') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf) ? this.getCustomLabel(tf) : this.getLabel(tf),
                        rowind: 0,
                        datatype: (this.checkInArray(['navdate', 'Corpus_Date', 'Inception_Date', 'Date'], tf)) ? 'date'
                          : (this.checkInArray(['Corpus', 'NAV', 'ALPHA', 'AVERAGE', 'BETA', 'RSQUARE', 'SHARPE', 'TREYNOR', 'Date'], tf)) ? 'numeric'
                            : '',
                        sort_order: (tf == 'MF_SCHCODE') ? 2
                          : (tf == 'CATEGORY') ? 3
                            : (tf == 'Inception_Date') ? 4
                              : (tf == 'SCHEME_NAM') ? 5
                                : (tf == 'Date') ? 8
                                  : (tf == 'Corpus') ? 6
                                    : (tf == 'Corpus_Date') ? 7
                                      : (tf == 'NAV') ? 9
                                        : (tf == 'ALPHA') ? 10
                                          : (tf == 'AVERAGE') ? 11
                                            : (tf == 'BETA') ? 12
                                              : (tf == 'RSQUARE') ? 13
                                                : (tf == 'SHARPE') ? 14
                                                  : (tf == 'TREYNOR') ? 15
                                                    : 99
                      });
                    }
                  })
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  //console.log(this.tableFields);
                }
              } else if (this.rawDataType === "scheme-profile-exp-ratio") {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                //console.log(this.rawData);
                if (response.data.length > 0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if (tf != '_id' && tf != 'mf_schcode' && tf != 'mf_schname' && tf != 'MF_SCHCODE' && tf != 'Mf_SchCode' && tf != 'Mf_SchCode' && tf != 'Mf_SchCode' && tf != 'SCH_NAME' && tf != 'sch_name' && tf != 'SCHEME_NAM') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getLabel(tf),
                        rowind: 0,
                        isLink: 0,
                        datatype: (tf == 'INVDATE') ? 'date' : '',
                        sort_order: (tf == 'Mf_SchCode') ? 1 : (tf == 'CO_NAME') ? 2
                          : (tf == 'mf_schname' || tf == 'mf_schname' || tf == 'SCH_NAME' || tf == 'sch_name') ? 3
                            : (tf == 'EXPRATIO') ? 4
                              : (tf == 'MaturityPeriod') ? 5
                                : (tf == 'SIP_MinInv') ? 6
                                  : (tf == 'inc_invest') ? 7
                                    : (tf == 'mininvt') ? 8
                                      : (tf == 'entry') ? 9
                                        : (tf == 'exit') ? 10
                                          : (tf == 'SIP_Exitload') ? 11
                                            : (tf == 'TAXB') ? 12
                                              : (tf == 'taxbname') ? 13
                                                : 99
                      });
                    }
                  });
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  //console.log(this.tableFields);
                }
              } else if (this.rawDataType === "scheme-master-info") {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                //console.log(this.rawData);
                if (response.data.length > 0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if (tf != '_id' && tf != 'mf_schcode' && tf != 'mf_schname' && tf != 'MF_SCHCODE' && tf != 'Mf_SchCode' && tf != 'Mf_SchCode' && tf != 'Mf_SchCode' && tf != 'SCH_NAME' && tf != 'sch_name' && tf != 'SCHEME_NAM') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf) ? this.getCustomLabel(tf) : this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf == 'Launc_Date' || tf == 'CLDATE') ? 'date' : '',
                        sort_order: (tf == 'Mf_SchCode') ? 1
                          : (tf == 'mf_schname' || tf == 'mf_schname' || tf == 'SCH_NAME' || tf == 'sch_name') ? 2
                            : (tf == 'SCHEME') ? 3
                              : (tf == 'LName') ? 4
                                : (tf == 'SIZE') ? 5
                                  : (tf == 'Launc_Date') ? 6
                                    : (tf == 'TypeName') ? 7
                                      : (tf == 'VClassCode') ? 8
                                        : (tf == 'VClass') ? 9
                                          : (tf == 'MININVT') ? 10
                                            : (tf == 'OFFERPRICE') ? 11
                                              : (tf == 'CLDATE') ? 12
                                                : (tf == 'Objective') ? 13
                                                  : 13
                      });
                    }
                  })
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  //console.log(this.tableFields);
                }
              } else if (this.rawDataType === "scheme-nav-latest" || this.rawDataType === "scheme-nav-historical") {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                //console.log(this.rawData);
                if (response.data.length > 0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if (tf != '_id' && tf != 'mf_schcode' && tf != 'mf_schname' && tf != 'MF_SCHCODE' && tf != 'Mf_SchCode' && tf != 'Mf_SchCode' && tf != 'Mf_SchCode' && tf != 'SCH_NAME' && tf != 'sch_name' && tf != 'SCHEME_NAM') {
                      this.tableFields.push({
                        title: tf,
                        name: (tf == 'scheme_info') ? 'Category' : this.getCustomLabel(tf) ? this.getCustomLabel(tf) : this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf == 'navdate' || tf == 'NAVDATE') ? 'date' : (tf == 'scheme_info') ? 'object' : '',
                        sort_order: (tf == 'mf_schcode') ? 1
                          : (tf == 'mf_schname' || tf == 'mf_schname' || tf == 'SCH_NAME' || tf == 'sch_name') ? 2
                            : (tf == 'scheme_info') ? 1
                              : (tf == 'navdate') ? 3
                                : (tf == 'Tax_Type') ? 4
                                  : (tf == 'ISIN') ? 5
                                    : (tf == 'NAV') ? 6
                                      : (tf == 'SellNav') ? 7
                                        : (tf == 'RePurchaseNAV') ? 8
                                          : 10
                      });
                    }
                  })
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  //console.log(this.tableFields);
                }
              } else if (this.rawDataType === "scheme-returns") {
                this.rawData = response.data.length > 0 ? [response.data[(response.data.length - 1)]] : [];
                this.searchData = this.rawData;
                //console.log(this.rawData);
                if (response.data.length > 0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if (tf != '_id') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf) ? this.getCustomLabel(tf) : this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf == 'LatNavDate' || tf == 'DATE') ? 'date'
                          : (this.checkInArray(['LatNavPrice', '1WEEK', 'WEEKMIN', 'WEEKMAX', 'WEEKAVG', '1MONTH', '1MMIN', '1MMAX', '1MAVG', '3MONTH', '3MMIN', '3MMAX', '3MAVG',
                            '6MONTH', '6MMIN', '6MMAX', '6MAVG', '1YEAR', '1YRMIN', '1YRMAX', '1YRAVG', '3YEAR', '3YRMIN', '3YRMAX', '3YRAVG', '5YEAR', '5YRMIN', '5YRMAX', '5YRAVG',
                            'inception', 'INCMIN', 'INCMAX', 'INCAVG'], tf)) ? 'numeric' : '',
                        sort_order: (tf == 'MF_SCHCODE') ? 1
                          : (tf == 'mf_schname' || tf == 'mf_schname' || tf == 'SCH_NAME' || tf == 'sch_name') ? 2
                            : (tf == 'SCHCLCODE') ? 3
                              : (tf == 'SCHCLASS') ? 4
                                : (tf == 'DATE') ? 4
                                  : (tf == 'LatNavDate') ? 5
                                    : (tf == 'LatNavPrice') ? 6
                                      : (tf == '1WEEK') ? 7
                                        : (tf == 'WMINCODE') ? 8
                                          : (tf == 'wminname') ? 9
                                            : (tf == 'WMAXCODE') ? 10
                                              : (tf == 'wmaxname') ? 11
                                                : (tf == 'WEEKMIN') ? 12
                                                  : (tf == 'WEEKMAX') ? 13
                                                    : (tf == 'WEEKAVG') ? 14
                                                      : (tf == '1MONTH') ? 15
                                                        : (tf == '1MMINCODE') ? 16
                                                          : (tf == '1mminname') ? 17
                                                            : (tf == '1MMAXCODE') ? 18
                                                              : (tf == '1mmaxname') ? 19
                                                                : (tf == '1MMIN') ? 20
                                                                  : (tf == '1MMAX') ? 21
                                                                    : (tf == '1MAVG') ? 22
                                                                      : (tf == '3MONTH') ? 23
                                                                        : (tf == '3MMINCODE') ? 24
                                                                          : (tf == '3mminname') ? 25
                                                                            : (tf == '3MMIN') ? 26
                                                                              : (tf == '3MMAXCODE') ? 26
                                                                                : (tf == '3mmaxname') ? 27
                                                                                  : (tf == '3MMIN') ? 28
                                                                                    : (tf == '3MMAX') ? 29
                                                                                      : (tf == '3MAVG') ? 30
                                                                                        : (tf == '6MONTH') ? 31
                                                                                          : (tf == '6MMINCODE') ? 32
                                                                                            : (tf == '6minname') ? 33
                                                                                              : (tf == '6MMAXCODE') ? 34
                                                                                                : (tf == '6mmaxname') ? 35
                                                                                                  : (tf == '6MIN') ? 36
                                                                                                    : (tf == '6MMAX') ? 37
                                                                                                      : (tf == '6MAVG') ? 38
                                                                                                        : (tf == '1YEAR') ? 39
                                                                                                          : (tf == '1YRMINCODE') ? 40
                                                                                                            : (tf == '1yrminname') ? 41
                                                                                                              : (tf == '1YRMAXCODE') ? 42
                                                                                                                : (tf == '1yrmaxname') ? 43
                                                                                                                  : (tf == '1YRMIN') ? 44
                                                                                                                    : (tf == '1YRMAX') ? 45
                                                                                                                      : (tf == '1YRAVG') ? 46
                                                                                                                        : (tf == '3YEAR') ? 47
                                                                                                                          : (tf == '3YRMINCODE') ? 48
                                                                                                                            : (tf == '3yrminname') ? 49
                                                                                                                              : (tf == '3YRMAXCODE') ? 50
                                                                                                                                : (tf == '3yrmaxname') ? 51
                                                                                                                                  : (tf == '3YRMIN') ? 52
                                                                                                                                    : (tf == '3YRMAX') ? 53
                                                                                                                                      : (tf == '3YRAVG') ? 54
                                                                                                                                        : (tf == '5YEAR') ? 55
                                                                                                                                          : (tf == '5YRMINCODE') ? 56
                                                                                                                                            : (tf == '5yrminname') ? 57
                                                                                                                                              : (tf == '5YRMAXCODE') ? 58
                                                                                                                                                : (tf == '5yrmaxname') ? 59
                                                                                                                                                  : (tf == '5YRMIN') ? 60
                                                                                                                                                    : (tf == '5YRMAX') ? 61
                                                                                                                                                      : (tf == '5YRAVG') ? 62
                                                                                                                                                        : (tf == 'inception') ? 63
                                                                                                                                                          : (tf == 'INCMINCODE') ? 64
                                                                                                                                                            : (tf == 'incminname') ? 65
                                                                                                                                                              : (tf == 'INCMAXCODE') ? 67
                                                                                                                                                                : (tf == 'incmaxname') ? 68
                                                                                                                                                                  : (tf == 'INCMIN') ? 69
                                                                                                                                                                    : (tf == 'INCMAX') ? 70
                                                                                                                                                                      : (tf == 'INCAVG') ? 71
                                                                                                                                                                        : 99
                      });
                    }
                  });
                  this.schemeReturnsFields = [
                    {
                      title: '1WEEK',
                      bsubtitle: '_1WRet',
                      subtitle: 'WEEK',
                      schname: 'w',
                      name: '1W',
                      rowind: 0,
                      datatype: 'numeric',
                      sort_order: '',
                    },
                    {
                      title: '1MONTH',
                      bsubtitle: '_1MRet',
                      subtitle: '1M',
                      schname: '1m',
                      name: '1M',
                      rowind: 0,
                      datatype: 'numeric',
                      sort_order: '',
                    },
                    {
                      title: '3MONTH',
                      bsubtitle: '_3MRet',
                      subtitle: '3M',
                      schname: '3m',
                      name: '3M',
                      rowind: 0,
                      datatype: 'numeric',
                      sort_order: '',
                    },
                    {
                      title: '6MONTH',
                      bsubtitle: '_6MRet',
                      subtitle: '6M',
                      schname: '6m',
                      name: '6M',
                      rowind: 0,
                      datatype: 'numeric',
                      sort_order: '',
                    },
                    {
                      title: '1YEAR',
                      bsubtitle: '_1YRet',
                      subtitle: '1YR',
                      schname: '1yr',
                      name: '1Yr',
                      rowind: 0,
                      datatype: 'numeric',
                      sort_order: '',
                    },
                    {
                      title: '3YEAR',
                      bsubtitle: '_3YRet',
                      subtitle: '3YR',
                      schname: '3yr',
                      name: '3Yr',
                      rowind: 0,
                      datatype: 'numeric',
                      sort_order: '',
                    },
                    {
                      title: '5YEAR',
                      bsubtitle: '_5YRet',
                      subtitle: '5YR',
                      schname: '5yr',
                      name: '5Yr',
                      rowind: 0,
                      datatype: 'numeric',
                      sort_order: '',
                    },
                    {
                      title: 'inception',
                      bsubtitle: '_IncRet',
                      subtitle: 'INC',
                      schname: 'inc',
                      name: 'Since Inception',
                      rowind: 0,
                      datatype: 'numeric',
                      sort_order: '',
                    },
                  ];
                  this.schemeReturnsRows = [
                    {
                      title: '1',
                      name: 'This Scheme',
                      rowind: 0,
                      datatype: 'numeric',
                      sort_order: '',
                    },
                    // { 
                    //   title: 'Category',
                    //   subtitle: '',
                    //   name: 'Category',
                    //   rowind: 0,
                    //   datatype: 'numeric',
                    //   sort_order: '',
                    // },
                    {
                      title: 'BM',
                      name: 'Benchmark',
                      subtitle: '',
                      rowind: 0,
                      datatype: 'numeric',
                      sort_order: '',
                    },
                    {
                      title: 'MAX',
                      name: 'Best in Category',
                      subtitle: 'maxname',
                      rowind: 0,
                      datatype: 'numeric',
                      sort_order: '',
                    },
                    {
                      title: 'MIN',
                      name: 'Worst in Category',
                      subtitle: 'minname',
                      rowind: 0,
                      datatype: 'numeric',
                      sort_order: '',
                    },
                    {
                      title: 'AVG',
                      name: 'AVG in Category',
                      subtitle: '',
                      rowind: 0,
                      datatype: 'numeric',
                      sort_order: '',
                    },
                  ];
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  //console.log(this.tableFields);
                }
                // this.getSchemeReturnRanks();
              } else if (this.rawDataType === 'fund-wise-monthly-aum') {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                //console.log(this.rawData);
                if (response.data.length > 0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if (tf != '_id') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf) ? this.getCustomLabel(tf) : this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf == 'AUMDate') ? 'date' : '',
                        sort_order: (tf == 'AMCCode') ? 1
                          : (tf == 'AMCName') ? 2
                            : (tf == 'AUM') ? 3
                              : (tf == 'AUMDate') ? 4
                                : 10
                      });
                    }
                  })
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  //console.log(this.tableFields);
                }
              } else if (this.rawDataType == 'analysis') {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.analysisPercHold = response.total_perc_hold;
                this.sum = response.sum ? response.sum : [];
                this.searchData = this.rawData;
                //console.log(this.rawData);
                if (response.data.length > 0) {
                  this.tableFields = this.analysisTableFields;
                }
              } else if (this.rawDataType === 'analysis-sum' || this.rawDataType === 'analysis-sum-latest') {
                this.rawData = [];
                this.rawData = response.data;
                this.searchData = this.rawData;
                //console.log("analysis-sum:", this.rawData);
                if (response.data) {
                  this.tableFields = this.analysisSumTableFields;
                  /* console.log('response.data >>>>', response.data.length)
                  if (response.data.length === 0) {
                    this.top3exposuresKeys = [];
                    this.top3industryKeys = [];
                    this.businessRatings = [];
                    this.valuationRatings = [];
                    this.qtrRatings = [];
                    this.debtRatings = [];
                    this.rawData = [];
                    return;
                  } */
                  // this.industryKeys = Object.keys(response.data.holdings_summary.industrywise);
                  let typewiseKeys = [];
                  try {
                    this.mcapKeys = Object.keys(response.data.holdings_summary.mcaptypewise);
                    typewiseKeys = Object.keys(response.data.holdings_summary.typewise);
                  } catch (error) {

                  }
                  let typewiseData = [];
                  let industryKeys = [];
                  let industryData = [];
                  typewiseKeys.forEach((indVal, indKey) => {
                    typewiseData.push({ name: indVal, value: parseFloat(response.data.holdings_summary.typewise[indVal].toFixed(2)), 'holdCount': response.data.holdings_summary.typewisenumber[indVal] });
                  });
                  try {
                    this.rawData.holdings_summary.typewise = this.sorted_fields_desc(typewiseData, 'value');
                    //console.log(this.rawData.holdings_summary.typewise);
                    this.top3exposuresKeys = Object.keys(response.data.holdings_summary.top_3_exposures);
                    this.top3industryKeys = Object.keys(response.data.holdings_summary.top_3_industrywise);
                    this.businessRatings = (response.data.holdings_summary.psumratingwise && response.data.holdings_summary.psumratingwise.business_rating) ? Object.keys(response.data.holdings_summary.psumratingwise.business_rating).reverse() : [];
                    this.valuationRatings = (response.data.holdings_summary.psumratingwise && response.data.holdings_summary.psumratingwise.valuation_rating) ? Object.keys(response.data.holdings_summary.psumratingwise.valuation_rating).reverse() : [];
                    this.qtrRatings = (response.data.holdings_summary.psumratingwise && response.data.holdings_summary.psumratingwise.quarterly_rating) ? Object.keys(response.data.holdings_summary.psumratingwise.quarterly_rating).reverse() : [];
                    this.debtRatings = (response.data.holdings_summary.psumratingwise && response.data.holdings_summary.psumratingwise.debt_rating) ? Object.keys(response.data.holdings_summary.psumratingwise.debt_rating).reverse() : [];
                    industryKeys = Object.keys(this.rawData.holdings_summary.industrywise);
                    industryKeys.forEach((indVal, indKey) => {
                      industryData.push({ name: indVal, value: parseFloat(response.data.holdings_summary.industrywise[indVal].toFixed(2)) });
                    });
                    this.rawData.holdings_summary.industrywise = this.sorted_fields_desc(industryData, 'value');
                  } catch (error) {
                  }


                  //console.log(this.rawData.holdings_summary.industrywise);
                  //RatingWise
                  let ratingKeys = [];
                  try {
                    ratingKeys = this.rawData.holdings_summary.ratingwise;
                  } catch (error) {
                    ratingKeys = [];
                  }
                  let ratingData = []; let ratingData1 = [];
                  if (ratingKeys.length !== 0) {
                    ratingKeys.forEach((indVal, indKey) => {
                      ratingData.push({
                        name: indVal.name,
                        PERC_HOLD: parseFloat(indVal['PERC_HOLD'].toFixed(2)),
                        sort_order: (indVal.name === 'AAA') ? 1 : (indVal.name === 'AA+') ? 2 : (indVal.name === 'AA') ? 3 : (indVal.name === 'AA-') ? 4 : (indVal.name === 'A+') ? 5 : (indVal.name === 'EQUITY') ? 6 : 7
                      });
                    });
                  }
                  try {
                    this.rawData.holdings_summary.clubbed_ratings.forEach((indVal, indKey) => {
                      ratingData1.push({
                        name: indVal.name,
                        PERC_HOLD: parseFloat(indVal['PERC_HOLD'].toFixed(2)),
                        sort_order: (indVal.name === 'AAA') ? 1 : (indVal.name === 'AA+') ? 2 : (indVal.name === 'AA') ? 3 : (indVal.name === 'AA-') ? 4 : (indVal.name === 'A+') ? 5 : (indVal.name === 'EQUITY') ? 6 : 7
                      });
                    });
                    this.rawData.holdings_summary.ratingwise = this.sorted_fields_asc(ratingData, 'sort_order');
                    this.rawData.holdings_summary.clubbed_ratings = this.sorted_fields_asc(ratingData1, 'sort_order');
                    //console.log(this.rawData.holdings_summary.ratingwise, this.rawData.holdings_summary.clubbed_ratings);
                    this.ratings.subFields = [
                      {
                        title: 'p11_S_%_hldg',
                        name: this.getCustomLabel('p11_S_%_hldg') ? this.getCustomLabel('p11_S_%_hldg') : this.getLabel('p11_S_%_hldg'),
                        datatype: 'numeric',
                        sort_order: 51,
                        sort: 0,
                        isSortable: 1
                      },
                      {
                        title: 'p11_quarterly_trends_%_hldg',
                        name: this.getCustomLabel('p11_quarterly_trends_%_hldg') ? this.getCustomLabel('p11_quarterly_trends_%_hldg') : this.getLabel('p11_quarterly_trends_%_hldg'),
                        datatype: 'numeric',
                        sort_order: 52,
                        sort: 0,
                        isSortable: 1
                      },
                      {
                        title: 'q1_a_b_greater_%_hldg',
                        name: this.getCustomLabel('q1_a_b_greater_%_hldg') ? this.getCustomLabel('q1_a_b_greater_%_hldg') : this.getLabel('q1_a_b_greater_%_hldg'),
                        datatype: 'numeric',
                        sort_order: 53,
                        sort: 0,
                        isSortable: 1
                      },
                      {
                        title: 'p11_debt_%_hldg',
                        name: this.getCustomLabel('p11_debt_%_hldg') ? this.getCustomLabel('p11_debt_%_hldg') : this.getLabel('p11_debt_%_hldg'),
                        datatype: 'numeric',
                        sort_order: 54,
                        sort: 0,
                        isSortable: 1
                      },
                      {
                        title: 'portfolio_overall_rating',
                        name: this.getCustomLabel('portfolio_overall_rating') ? this.getCustomLabel('portfolio_overall_rating') : this.getLabel('portfolio_overall_rating'),
                        datatype: 'numeric',
                        sort_order: 55,
                        sort: 0,
                        isSortable: 1
                      }
                    ];
                  } catch (error) {

                  }
                  let q1_a_greaterValue = {};
                  let q1_b_greaterGrowth = {};
                  try {
                    q1_a_greaterValue = this.rawData['holdings_summary']['mcaptypewisenew']['q1_a_greater']['PERC_HOLD'];
                    q1_b_greaterGrowth = this.rawData['holdings_summary']['mcaptypewisenew']['q1_b_greater']['PERC_HOLD'];
                  } catch (error) {
                    console.log('error:::', error);
                  }

                  //console.log("q1_a_greaterValue:::", q1_a_greaterValue, "q1_b_greaterGrowth", q1_b_greaterGrowth, this.rawData);

                  this.valueVsGrowthTotal = { value: 0, growth: 0, total: 0, noofstocksv: 0, noofstocksg: 0, noofstocks: 0 };
                  this.valueGrowthData = [];
                  let valueTotal = 0;
                  let overAllTotal = 0;
                  let noofstocksv = 0; let noofstocksg = 0; let noofstocks = 0;



                  if (q1_a_greaterValue) {
                    for (let [item, key] of Object.entries(q1_a_greaterValue)) {
                      //console.log('item', item); 
                      let growthValueData = {
                        title: '',
                        value: '',
                        growth: '',
                        noofstocksv: 0,
                        noofstocksg: 0,
                        noofstocksmcap: 0,
                        sum: 0,
                      }
                      growthValueData.title = item;
                      growthValueData.value = key;
                      growthValueData.sum += key;
                      growthValueData.noofstocksv = this.rawData['holdings_summary']['mcaptypewisenew']['q1_a_greater']['number'][item];
                      growthValueData.noofstocksmcap += this.rawData['holdings_summary']['mcaptypewisenew']['q1_a_greater']['number'][item];
                      noofstocksv += this.valueVsGrowthTotal.noofstocksv + this.rawData['holdings_summary']['mcaptypewisenew']['q1_a_greater']['number'][item];
                      noofstocks += this.rawData['holdings_summary']['mcaptypewisenew']['q1_a_greater']['number'][item];
                      valueTotal = valueTotal + key;
                      overAllTotal = overAllTotal + key;
                      this.valueGrowthData.push(growthValueData);
                    }
                  }
                  //console.log('VALUEvsGROWTH', this.valueGrowthData);
                  let growthTotal = 0;
                  if (q1_b_greaterGrowth) {
                    for (let [item, key] of Object.entries(q1_b_greaterGrowth)) {
                      //console.log('item', item);
                      let index = this.valueGrowthData.findIndex(res => {
                        return res.title == item
                      });
                      //console.log("#=> "+index, key);
                      if (index != -1) {
                        this.valueGrowthData[index].growth = key;
                        this.valueGrowthData[index].sum += key;
                        growthTotal = growthTotal + key;
                        overAllTotal = overAllTotal + key;
                        this.valueGrowthData[index].noofstocksg = this.rawData['holdings_summary']['mcaptypewisenew']['q1_b_greater']['number'][item];
                        this.valueGrowthData[index].noofstocksmcap += this.rawData['holdings_summary']['mcaptypewisenew']['q1_b_greater']['number'][item];
                        noofstocksg += this.rawData['holdings_summary']['mcaptypewisenew']['q1_b_greater']['number'][item];
                        noofstocks += this.rawData['holdings_summary']['mcaptypewisenew']['q1_b_greater']['number'][item];
                      } else {
                        let growthValueData = {
                          title: '',
                          value: '',
                          growth: '',
                          sum: 0,
                        }
                        growthValueData.title = item;
                        growthValueData.growth = key;
                        growthValueData.sum += key;
                        growthTotal = growthTotal + key;
                        overAllTotal = overAllTotal + key;
                        //console.log(growthValueData);
                        // this.valueVsGrowthTotal.total = this.valueVsGrowthTotal.total + growthValueData.sum;
                        this.valueGrowthData.push(growthValueData);
                      }
                    }
                  }
                  this.valueVsGrowthTotal = { value: valueTotal, growth: growthTotal, total: overAllTotal, noofstocksv: noofstocksv, noofstocksg: noofstocksg, noofstocks: noofstocks };
                  //console.log('valueGrowthData result', overAllTotal, growthTotal, valueTotal, this.valueVsGrowthTotal, this.valueGrowthData);
                }
              } else if (this.rawDataType === "sector-historical") {
                this.rawData = [];
                this.searchData = this.rawData;
                if (response.data) {
                  for (const [index, [key, value]] of Object.entries(Object.entries(response.data))) {
                    if (index == 0) {
                      this.tableFields = [{ data_type: 'date', key: 'Date', title: 'Date' }];
                      for (let th of Object.keys(value)) {
                        // console.log('table heading', th);
                        const thData = { data_type: 'perc', key: th, title: th };
                        this.tableFields.push(thData);
                      }
                    }
                    this.rawData[index] = [];
                    this.tableFields.forEach((item, ci) => {
                      // console.log('tableFields', index, ci, item, {[item]: key});
                      if (item.key == 'Date') {
                        this.rawData[index].push({ [item.key]: key });
                      } else {
                        this.rawData[index].push({ [item.key]: value[item.key] });
                      }
                    })
                    // this.rawData[index]['Holding'] = key;
                    // console.log('index', index);
                    // console.log('key', key);
                    // console.log('value', value);
                  }
                }
                //console.log('rawData===>>', this.rawData);
                // console.log('tableFields<<<<>>>>>', this.tableFields);
                // this.rawData;              
              } else if (this.rawDataType == 'sip-dates') {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                //console.log(this.rawData);
                if (response.data.length > 0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if (tf != '_id' && tf != 'MF_SCHCODE') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf) ? this.getCustomLabel(tf) : this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf == 'TRANS_DATE') ? 'date' : '',
                        sort_order: (tf == 'MF_COCODE') ? 1
                          : (tf == 'MF_SCHCODE') ? 2
                            : (tf == 'mf_schname' || tf == 'mf_schname' || tf == 'SCH_NAME' || tf == 'sch_name') ? 2
                              : (tf == 'PLAN') ? 3
                                : (tf == 'Frequency') ? 4
                                  : (tf == 'MinAmt') ? 5
                                    : (tf == 'D1') ? 6
                                      : (tf == 'D2') ? 7
                                        : (tf == 'D3') ? 8
                                          : (tf == 'D4') ? 9
                                            : (tf == 'D5') ? 10
                                              : (tf == 'D6') ? 11
                                                : (tf == 'D7') ? 12
                                                  : (tf == 'D8') ? 13
                                                    : (tf == 'D9') ? 14
                                                      : (tf == 'D10') ? 15
                                                        : (tf == 'ANY') ? 16
                                                          : 19
                      });
                    }
                  })
                }
                this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                //console.log(this.tableFields);
              } else if (this.rawDataType == 'dividend-details') {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                //console.log(this.rawData);
                if (response.data.length > 0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if (tf != '_id' && tf != 'mf_schcode' && tf != 'mf_schname' && tf != 'MF_SCHCODE' && tf != 'Mf_SchCode' && tf != 'Mf_SchCode' && tf != 'Mf_SchCode' && tf != 'SCH_NAME' && tf != 'sch_name' && tf != 'SCHEME_NAM' && tf != 'Sch_Name') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf) ? this.getCustomLabel(tf) : this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf == 'NAVDATE' || tf == 'DivDate' || tf == 'RecordDate') ? 'date'
                          : (this.checkInArray(['ONE_WEEK', 'ONE_MONTH', 'THREE_MONTH', 'SIX_MONTH', 'ONE_YEAR', 'THREE_YEAR', 'FIVE_YEAR'], tf)) ? 'numeric' : '',
                        sort_order: (tf == 'MF_COCODE') ? 1
                          : (tf == 'Mf_SchCode') ? 2
                            : (tf == 'mf_schname' || tf == 'mf_schname' || tf == 'SCH_NAME' || tf == 'sch_name' || tf == 'Sch_Name') ? 3
                              : (tf == 'LName') ? 4
                                : (tf == 'VClassCode') ? 5
                                  : (tf == 'VClass') ? 6
                                    : (tf == 'TypeName') ? 7
                                      : (tf == 'NAVRS') ? 8
                                        : (tf == 'NAVDATE') ? 9
                                          : (tf == 'Divtype') ? 10
                                            : (tf == 'DivDate') ? 11
                                              : (tf == 'DIVTYPCODE') ? 12
                                                : (tf == 'DivPer') ? 13
                                                  : (tf == 'DIVPERPU') ? 14
                                                    : (tf == 'DivAmount') ? 15
                                                      : (tf == 'ONE_WEEK') ? 16
                                                        : (tf == 'ONE_MONTH') ? 17
                                                          : (tf == 'THREE_MONTH') ? 18
                                                            : (tf == 'SIX_MONTH') ? 19
                                                              : (tf == 'ONE_YEAR') ? 20
                                                                : (tf == 'THREE_YEAR') ? 21
                                                                  : (tf == 'FIVE_YEAR') ? 22
                                                                    : (tf == 'RecordDate') ? 15
                                                                      : 29
                      });
                    }
                  })
                }
                this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                //console.log(this.tableFields);
              } else if (this.rawDataType === "scheme-asset-allocation") {
                // if('CurrentMonth' in response && response.CurrentMonth){
                //   this.CurrentMonthHolding = response.CurrentMonth.split('T')[0];
                // }
                this.rawData = [];
                this.searchData = this.rawData;
                if (response.data) {
                  for (const [index, [key, value]] of Object.entries(Object.entries(response.data))) {
                    if (index == 0) {
                      this.tableFields = [{ data_type: 'date', key: 'CurrentMonth', title: 'Date' }];
                      for (let th of Object.keys(value)) {
                        //console.log('table heading', th);
                        if (th !== 'CurrentMonth') {
                          const thData = { data_type: 'perc', key: th, title: th };
                          this.tableFields.push(thData);
                        }
                      }
                    }
                    this.rawData[index] = [];
                    this.tableFields.forEach((item, ci) => {
                      //console.log('tableFields', index, ci, item, { [item]: key });
                      if (item.key == 'CurrentMonth') {
                        this.rawData[index].push({ [item.key]: value[item.key] });
                      } else {
                        this.rawData[index].push({ [item.key]: value[item.key] });
                      }
                    })
                    // this.rawData[index]['Holding'] = key;
                    // console.log('index', index);
                    // console.log('key', key);
                    // console.log('value', value);
                  }
                  //console.log(this.rawData);
                  this.rawData = this.rawData;
                  //console.log(this.rawData);
                }
                // console.log('rawData===>>', this.rawData);
                // console.log('tableFields<<<<>>>>>', this.tableFields);
                // this.rawData.reverse();
              } else if (this.rawDataType === 'scheme-aum') {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                //console.log(this.rawData);
                if (response.data.length > 0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if (tf != '_id' && tf != 'MF_SCHCODE' && tf != 'MF_SCHCODE' && tf != 'sch_name' && tf != 'SCH_NAME') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf) ? this.getCustomLabel(tf) : this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf == 'AUMDate') ? 'date' : '',
                        sort_order: (tf == 'mf_schcode' || tf == 'MF_SCHCODE') ? 1
                          : (tf == 'mf_schname' || tf == 'mf_schname' || tf == 'SCH_NAME' || tf == 'sch_name') ? 2
                            : (tf == 'AUM') ? 4
                              : (tf == 'AUMDate') ? 3
                                : 10
                      });
                    }
                  })
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  //console.log(this.tableFields);
                }
              } else if (this.rawDataType === 'whats-in-out') {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                //console.log(this.rawData);
                if (response.data.length > 0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if (tf != '_id' && tf != 'mf_schcode' && tf != 'mf_schname' && tf != 'SCH_NAME') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf) ? this.getCustomLabel(tf) : this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf == 'PortfolioDate' || tf == 'invdate') ? 'date' : (tf == 'mktvalue') ? 'numeric' : '',
                        sort_order: (tf == 'mf_schcode') ? 1
                          : (tf == 'mf_schname' || tf == 'SCH_NAME') ? 2
                            : (tf == 'CO_CODE') ? 3
                              : (tf == 'CO_NAME') ? 4
                                : (tf == 'mktvalue') ? 5
                                  : (tf == 'mktvalue') ? 6
                                    : (tf == 'rating') ? 7
                                      : (tf == 'NO_SHARES') ? 8
                                        : (tf == 'Perc_Hold') ? 9
                                          : (tf == 'invdate') ? 10
                                            : (tf == 'PortfolioDate') ? 11
                                              : 13
                      });
                    }
                  })
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  //console.log(this.tableFields);
                  this.showWhatsIn = true;
                  this.rawData.forEach((val, key) => {
                    if ('direction' in val && val.direction == 'In') {
                      this.whatsIn.push(val);
                    } else if ('direction' in val && val.direction == 'Out') {
                      this.whatsOut.push(val);
                    }
                  });
                  //console.log(this.whatsIn, this.whatsOut);
                }
              } else if (this.rawDataType == 'scheme-return-ranks') {
                this.rawData = response.data.length > 0 ? response.data : [];
                //console.log(this.rawData);
                this.schemeReturnRanks = [];
                if (response.data.length > 0) {
                  this.schemeReturnRankDate = response.data[0].DATE.split('T')[0];
                  var tableCols = [];
                  // var tableRows = [{ title: 'VALUE', name: 'Value', dataType: 'numeric'}, { title: 'RANK', name: 'Rank', dataType: 'string'}];
                  // this.schemeReturnRankRows = tableRows;
                  if (response.durations) {
                    response.durations.forEach((durVal, durKey) => {
                      tableCols[durKey] = { title: durVal, total: {} };
                      /* response.totals.forEach((totalVal) => {
                        if (totalVal.DURATION === durVal) {
                          tableCols[durKey]['total'] = totalVal;
                        }
                      }); */
                    });
                    this.schemeReturnRankCols = tableCols;
                    //console.log(this.schemeReturnRankCols);
                    var tableData = [];
                    // response.data.forEach((dateVal, dateKey) => {
                    //   tableData[rankKey] = {date: rankVal.sch_name};
                    response.data.forEach((rankVal, rankKey) => {
                      //console.log(rankVal);
                      tableData[rankKey] = { Date: rankVal.DATE.split('T')[0], Date1: rankVal.DATE.split('T')[0] };
                      response.durations.forEach((durVal, durKey) => {
                        tableData[rankKey][durVal] = {};
                        rankVal.result.forEach((rVal, rKey) => {
                          // rankVal.forEach((rankDurVal, rankDurKey) => {
                          if (rVal.DURATION === durVal) {
                            tableData[rankKey][durVal] = { DURATION: rVal.DURATION, RANK: rVal.RANK, VALUE: rVal.VALUE, TOTAL: rVal.TOTAL };
                          }
                          // });
                        });
                      });
                    });
                    var tableData1 = [];
                    /* response.totals.forEach((rankVal, rankKey) => {
                      console.log(rankVal);
                      tableData1[rankKey] = { Date: rankVal.DATE.split('T')[0], Date1: rankVal.DATE.split('T')[0] };
                      response.durations.forEach((durVal, durKey) => {
                        console.log(durVal);
                        tableData1[rankKey][durVal] = { total: {} };
                        rankVal.result.forEach((rVal, rKey) => {
                          // rankVal.forEach((rankDurVal, rankDurKey) => {
                          if (rVal.DURATION === durVal) {
                            tableData1[rankKey][durVal]['total'] = { DURATION: rVal.DURATION, TOTAL: rVal.TOTAL };
                          }
                          // });
                        });
                      });
                    }); */
                  }
                  //console.log(tableData, tableData1, tableCols);
                  this.schemeReturnRanks = tableData; // this.sorted_fields_date(tableData, 'Date1').reverse();
                  //this.schemeReturnRankTotals = tableData1; //this.sorted_fields_date(tableData1, 'Date1').reverse();
                  //console.log(this.schemeReturnRanks, this.schemeReturnRankTotals);
                }
              } else if (this.rawDataType == 'scheme-rolling-returns') {
                this.rawData = response.data;
              } else {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                //console.log(this.rawData);
                if (response.data.length > 0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if (tf != '_id') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf) ? this.getCustomLabel(tf) : this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf == 'navdate') ? 'date' : '',
                        sort_order: (tf == 'mf_schcode') ? 1
                          : (tf == 'mf_schname' || tf == 'SCH_NAME') ? 2
                            : (tf == 'CO_CODE') ? 3
                              : (tf == 'CO_NAME') ? 4
                                : (tf == 'mktvalue') ? 5
                                  : (tf == 'NAV') ? 6
                                    : (tf == 'SellNav') ? 7
                                      : (tf == 'RePurchaseNAV') ? 8
                                        : 10
                      });
                    }
                  })
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  //console.log(this.tableFields);
                }
              }
              //console.log("this.rawData", this.tableFields);
              this.rawDataList[this.selRowInd].items = this.rawData;
              if (response.total_pages) {
                myself.perPage = myself.rawData.length;
                myself.totalPages = response.total_pages ? response.total_pages : 1;
                let i = 8;
                let page = myself.current_page - 2;
                if (page <= 0) page = 1;
                myself.pages = [];
                while (i) {
                  myself.pages.push(parseInt(page));
                  if (myself.totalPages <= page) break;
                  page++;
                  i--;
                }
              }
              //TODO:: add company updates into our array in future
            } else {
              this.isloading = false;
            }
            if ((this.rawDataType === 'scheme-nav-historical' || this.rawDataType == 'scheme-rolling-returns') && response.responseType === 'success') {
              this.isDownload = 0;
              this.isApiCalled = 0;
              window.open(response.download_link, '_blank');
            }
            this.isApiCalled = 0;
            this.disabledDates = { from: new Date(new Date().setDate(new Date().getDate() - 1)) };
          }
        );
      }
    },
    getTabData(tabIndex, newTab, oldTab) {
      //console.log(this.selRowInd, tabIndex, this.selRowInd != tabIndex);
      //console.log("### TabChange", this.selRowInd, tabIndex, newTab, oldTab, this.rawDataList);
      //console.log("### TabChange", this.selRowInd, tabIndex);
      if (this.selRowInd != tabIndex) {
        this.isloading = true;
        this.clearPagination();
        this.ratings.subFields = [];
        this.rawDataList[this.selRowInd].open = false;
        this.selRowInd = tabIndex;
        this.rawDataType = this.rawDataList[tabIndex].id;
        //console.log(">>> this.rawDataType", this.rawDataType)
        this.selSchemeTab = this.rawDataList[tabIndex].value;
        localStorage.setItem("schemeTab", this.rawDataType);
        localStorage.setItem("selSchemeTab", this.selSchemeTab);
        this.resetFilter();
        this.getRawData();
      } else if (this.selRowInd == tabIndex) {
        this.selRowInd = tabIndex;
      }
      if (this.rawDataType === 'analysis-sum') {
        this.isloading = true;
        this.resetFilter();
        this.getRawData();
      }
      this.getFilerDate();
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.fillTable();
    },
    next() {
      //console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.prevDisabled = 0;
      this.fillTable();
    },
    fillTable() {
      this.page = this.pageToLoad;
      if (this.pageToLoad == this.totalPages) {
        this.nextDisabled = 1;
      } else {
        this.nextDisabled = 0;
      }
      if (this.pageToLoad == 1) {
        this.prevDisabled = 1;
      } else {
        this.prevDisabled = 0;
      }
      this.current_page = this.pageToLoad;
      this.getRawData();
    },
    clearPagination() {
      this.page = 1;
      this.current_page = 1;
      this.pageToLoad = 1;
      this.totalPages = 1;
      this.prevDisabled = 1;
      this.nextDisabled = 0;
      this.pages = [];
    },
    showSchemeHoldings(mfcode) {
      //console.log('mfcode', mfcode);
      // this.$router.push({ name: 'Holdings', params: { id: mfcode } })
      // <router-link class="a-btn" :to="'/schemeholdings/:id/' tr[cl.title]">{{tr[cl.title]}}</router-link>
      this.$router.push({ path: `/schemeholdings/${mfcode}` });
    },
    showSchemeRatios(mfcode) {
      //console.log('mfcode', mfcode);
      // this.$router.push({ name: 'Holdings', params: { id: mfcode } })
      // <router-link class="a-btn" :to="'/schemeholdings/:id/' tr[cl.title]">{{tr[cl.title]}}</router-link>
      this.$router.push({ path: `/schemeratios/${mfcode}` });
    },
    search() {
      if (this.searchText === null || this.searchText === "") {
        this.rawData = this.searchData;
        return this.rawData;
      } else if (this.searchText.length <= 2) {
        this.rawData = this.searchData;
        return this.rawData;
      }
      if (this.searchText.length > 2 || e.keyCode === 13) {
        this.rawData = this.searchData.filter(rd => {
          return (
            rd.nameamc.toLowerCase().includes(this.searchText.toLowerCase()) ||
            (rd.LNAME ?
              rd.LNAME.toLowerCase().includes(this.searchText.toLowerCase()) :
              false)
          );
        });
      }
    },
    filterSchemes() {
      if (this.scheme_name.length > 1 || this.durDate != null) {
        this.getRawData();
      } else {
        this.getRawData();
      }
    },
    resetFilter() {
      this.fund_manager = this.scheme_name = this.category = '';
      this.durDate = null;
      this.sum = {};
      this.getRawData();
    },
    getSchemesList() {
      let _this = this;
      http.get("mutual-funds/schemes?onlyCodeAndNames=1", {}, function (error, response) {
        //   http.get("mutual-funds/schemes?page=1", {}, function(error, response) {
        if (response.status == 'success') {
          var schemeList = response.data;
          var uniqueFundManagers = [];
          if (schemeList.length > 0) {
            schemeList.forEach((scheme) => {
              //   console.log(scheme);
              _this.schemeList.push({ id: scheme.mf_schcode, name: scheme.sch_name });
              if (_this.$route.params.id && _this.$route.params.id == scheme.mf_schcode) {
                _this.selScheme = { id: scheme.mf_schcode, name: scheme.sch_name };
                localStorage.setItem("selscheme", JSON.stringify(_this.selScheme));
              }
            });
            _this.schemeList = _this.sorted_fields_asc(
              _this.schemeList,
              "id"
            );
            if (!localStorage.getItem("selscheme")) {
              _this.selScheme = _this.schemeList[0];
              localStorage.setItem("selscheme", JSON.stringify(_this.selScheme));
            } else {
              _this.selScheme = JSON.parse(localStorage.getItem("selscheme"));
            }
            //console.log("Selected Scheme", typeof _this.selScheme, _this.schemeList);
          }
        }
        /* if (response.status === 'success') {
          const schemeList = response.data || [];

          if (!schemeList.length) return;

          const mappedList = schemeList.map(scheme => ({
            id: scheme.mf_schcode,
            name: scheme.sch_name
          }));

          _this.schemeList = _this.sorted_fields_asc(mappedList, 'id');

          const routeId = _this.$route.params.id;
          const storedScheme = localStorage.getItem('selscheme');

          let selectedScheme =
            (routeId && _this.schemeList.find(s => s.id == routeId)) ||
            (storedScheme && JSON.parse(storedScheme)) ||
            _this.schemeList[0];

          _this.selScheme = selectedScheme;
          localStorage.setItem('selscheme', JSON.stringify(selectedScheme));
        } */
      });
    },
    getSchemeRawData() {
      //console.log("Get RawData", this.selScheme);
      const _this = this;
      if (_this.selScheme !== "") {
        /* localStorage.setItem("selscheme", JSON.stringify(this.selScheme));
        this.durDate = null;
        this.getFilerDate();
        this.getRawData(); */
        if (this.selScheme !== "") {
          localStorage.setItem("selscheme", JSON.stringify(_this.selScheme));

          setTimeout(() => {
            _this.durDate = null;
            _this.getFilerDate();
            _this.getRawData();
          }, 500);
        }
      }
    },
    getDateData(e) {
      // console.log("Date Selected", e);
      if (this.rawDataType == 'scheme-holdings') {
        this.durDate = e;
        this.filterSchemes();
      } else {
        this.durDate = e;
        this.filterSchemes();
      }
    },
    getRollingDuration(e) {
      //console.log('Selected Duration', e);
      this.selDuration = e;
      this.getRawData();
    },
    getSchemeReturnRanks() {
      let _this = this;
      var API = "mutual-funds/scheme-return-ranks/" + _this.selScheme.id;
      //console.log('API >>>', API)
      if (_this.durDate != null) {
        API = API + "?date=" + _this.getYMDDate(_this.durDate);
      }
      http.get(API, {}, function (error, response) {
        if (!error) {
          if (response.status == 'success') {
            _this.schemeReturnsRankData = response;
            //console.log("#### getSchemeReturnRanks:", _this.schemeReturnsRankData);
            var tableCols = [];
            var tableRows = [
              { title: 'VALUE', name: 'Value', dataType: 'numeric' }, { title: 'RANK', name: 'Rank', dataType: 'string' }, { title: 'TOTAL', name: 'Total', dataType: 'string' },
            ];
            _this.schemeReturnRankRows = tableRows;
            if (response.durations) {
              response.durations.forEach((durVal, durKey) => {
                // tableCols.push([]);
                tableCols[durKey] = { title: durVal, data: [], total: {} };
                response.data.forEach((rankVal) => {
                  if (rankVal.DURATION === durVal) {
                    tableCols[durKey].data = rankVal;
                  }
                });
                response.totals.forEach((totalVal) => {
                  if (totalVal.DURATION === durVal) {
                    tableCols[durKey]['total'] = totalVal;
                  }
                });
              });
            }
            //console.log("tableCols: ",tableCols);
            _this.schemeReturnRanks = tableCols;
            if (response.data)
              _this.schemeReturnRankDate = (response.data[0].DATE).split('T')[0];
          }
        }
      });
    }
  },
  data() {
    return {
      isloading: false,
      last_updated_date: null,
      latest_date_used_for_calc: null,
      durDate: null,
      // durDate: new Date().setDate(new Date().getDate() - 1),
      disabledDates: {
        from: new Date(new Date().setDate(new Date().getDate() - 1))
      },
      valueVsGrowthTotal: { value: 0, growth: 0, total: 0, noofstocksv: 0, noofstocksg: 0, noofstocks: 0 },
      selSchemeTab: "",
      schemeReturnsRankData: [],
      schemeReturnRanks: [],
      schemeReturnRankRows: [],
      schemeReturnRankCols: [],
      //schemeReturnRankTotals: [],
      schemeReturnRankDate: '',
      tableFields: [],
      schemeReturnsFields: [],
      schemeReturnsRows: [],
      searchText: "",
      selScheme: null,
      schemeList: [],
      scheme_name: '',
      category: '',
      invType: '',
      actions: [],
      isApiCalled: 0,
      param: "scheme-master-info",
      currentComp: "",
      SCH_Table_NAME: '',
      CurrentMonthHolding: null,
      dateFilterTabs: ['scheme-aum', 'whats-in-out', 'scheme-asset-allocation', 'dividend-details',
        'scheme-ratios', 'scheme-returns', 'scheme-nav-historical', 'sector-historical', 'analysis', 'analysis-sum', 'analysis-sum-latest',
        'category-wise-returns', 'scheme-return-ranks'],
      durationForRollingReturns: ["3M", "1Y", "3Y", "5Y"],
      selDuration: '3M',
      schemeRollingTableFields: [
        {
          title: 'nav', name: 'NAV', dataType: 'display', sort_order: 1, subFields:
            [{ title: 'standard_deviation', name: 'SD', dataType: 'numeric', sort_order: 1 }, { title: 'mean', name: 'Mean', dataType: 'numeric', sort_order: 1 }]
        },
        { title: 'standard_deviation', name: 'SD', dataType: 'numeric', sub_title: 'NAV_RR' }, { title: 'mean', name: 'Mean', dataType: 'numeric', sub_title: 'NAV_RR' },
        {
          title: 'BSE_SENSEX', name: 'BSE SENSEX', dataType: 'display', sort_order: 1, subFields:
            [{ title: 'standard_deviation', name: 'SD', dataType: 'numeric', sort_order: 1 }, { title: 'mean', name: 'Mean', dataType: 'numeric', sort_order: 1 }]
        },
        { title: 'standard_deviation', name: 'SD', dataType: 'numeric', sort_order: 1, sub_title: 'BSE_SENSEX_RR' }, { title: 'mean', name: 'Mean', dataType: 'numeric', sort_order: 1, sub_title: 'BSE_SENSEX_RR' },
        {
          title: 'BSE_500', name: 'BSE 500', dataType: 'display', sort_order: 1, subFields:
            [{ title: 'standard_deviation', name: 'SD', dataType: 'numeric', sort_order: 1 }, { title: 'mean', name: 'Mean', dataType: 'numeric', sort_order: 1 }]
        },
        { title: 'standard_deviation', name: 'SD', dataType: 'numeric', sub_title: 'BSE_500_RR' }, { title: 'mean', name: 'Mean', dataType: 'numeric', sub_title: 'BSE_500_RR' }
      ],
      schemeRollingTableRows: [
        { title: 'bse_500_rr_negative', name: 'BSE 500 Negaitive', },
        { title: 'bse_500_rr_positive', name: 'BSE 500 Positive' },
        { title: 'bse_sensex_rr_negative', name: 'BSE Sensex Negaitive' },
        { title: 'bse_sensex_rr_positive', name: 'BSE Sensex Positive' },
        { title: 'nav_rr_grtr_than_bse_500_rr', name: 'NAV > BSE 500' },
        { title: 'nav_rr_grtr_than_bse_sensex_rr', name: 'NAV > BSE Sensex' },
        { title: 'nav_greater_than_positive_bse_500_rr', name: 'NAV > BSE 500 Positive' },
        { title: 'nav_greater_than_positive_bse_sensex_rr', name: 'NAV > BSE Sensex Positive' },
        { title: 'nav_less_than_negative_bse_500_rr', name: 'NAV < BSE 500 Negaitive' },
        { title: 'nav_less_than_negative_bse_sensex_rr', name: 'NAV < BSE Sensex Negative' }
      ],
      schemeRollingTableRowsPercent: [
        { title: 'nav_rr_grtr_than_bse_500_rr', name: 'NAV > BSE 500' },
        { title: 'nav_rr_grtr_than_bse_sensex_rr', name: 'NAV > BSE Sensex' },
        { title: 'nav_greater_than_positive_bse_500_rr', name: 'NAV > BSE 500 Positive' },
        { title: 'nav_greater_than_positive_bse_sensex_rr', name: 'NAV > BSE Sensex Positive' },
        { title: 'nav_less_than_negative_bse_500_rr', name: 'NAV < BSE 500 Negaitive' },
        { title: 'nav_less_than_negative_bse_sensex_rr', name: 'NAV < BSE Sensex Negative' }
      ],
      basicTableRows: [
        /* { title: 'MF_COCODE', name: this.getLabel('MF_COCODE'), isLink: 0, datatype: '', sort_order: 1 }, */
        { title: 'amficode', name: this.getLabel('amficode'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'mf_schcode', name: this.getLabel('mf_schcode'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'ClassCode', name: this.getLabel('ClassCode'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'Category', name: this.getLabel('Category'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'sch_name', name: this.getLabel('sch_name'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'navrs', name: this.getLabel('navrs'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'riskometervalue', name: this.getLabel('riskometervalue'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'navdate', name: this.getLabel('navdate'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'rtcode', name: this.getLabel('rtcode'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'isin', name: this.getLabel('isin'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'isin_Reinvestment', name: this.getLabel('isin_Reinvestment'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'FundManager', name: this.getLabel('FundManager'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'LaunchDate', name: this.getLabel('LaunchDate'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'MinInvestment', name: this.getLabel('MinInvestment'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'IncrementalInvestment', name: this.getLabel('IncrementalInvestment'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'MinInvestment_SIP', name: this.getLabel('MinInvestment_SIP'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'Frequency', name: this.getLabel('Frequency'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'SchemeAUM', name: this.getLabel('SchemeAUM'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'EntrytLoad', name: this.getLabel('EntrytLoad'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'ExitLoad', name: this.getLabel('ExitLoad'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'FundType', name: this.getLabel('FundType'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'InvestmentType', name: this.getLabel('InvestmentType'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'MCAPCategory', name: this.getLabel('MCAPCategory'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'BMCode', name: this.getLabel('BMCode'), isLink: 0, datatype: '', sort_order: 1 },
        { title: 'BenchmarkName', name: this.getLabel('BenchmarkName'), isLink: 0, datatype: '', sort_order: 1 }
      ],
      rawDataList: [
        // { id: "scheme-master-info", value: "Scheme Master Info", open: false, items: {}, isPaginate: 0 },
        { id: "basic", value: "Basic", open: false, items: {}, isPaginate: 0 },
        { id: "scheme-holdings", value: "Holdings", open: false, items: {}, isPaginate: 0 },
        { id: "scheme-ratios", value: "Scheme Ratios", open: false, items: {}, isPaginate: 0 },
        { id: "scheme-profile-exp-ratio", value: "Profile Exp Ratios", open: false, items: {}, isPaginate: 0 },
        { id: "analysis", value: "Analysis", open: false, items: {}, isPaginate: 0 },
        { id: "analysis-sum", value: "Analysis Sum", open: false, items: {}, isPaginate: 0 },
        { id: "analysis-sum-latest", value: "Latest Analysis Sum", open: false, items: {}, isPaginate: 0 },
        { id: "scheme-returns", value: "Scheme Returns", open: false, items: {}, isPaginate: 0 },
        { id: "scheme-nav-latest", value: "Scheme NAV Latest", open: false, items: {}, isPaginate: 1 },
        { id: "scheme-nav-historical", value: "Scheme NAV Historical", open: false, items: {}, isPaginate: 1 },
        { id: "sector-historical", value: "Sector Historical", open: false, items: {}, isPaginate: 0 },
        { id: "dividend-details", value: "Dividend Details", open: false, items: {}, isPaginate: 1 },
        { id: "sip-dates", value: "SIP Dates", open: false, items: {}, isPaginate: 1 },
        { id: "scheme-asset-allocation", value: "Scheme Asset Allocation", open: false, items: {}, isPaginate: 0 },
        { id: "scheme-aum", value: "Scheme AUM", open: false, items: {}, isPaginate: 0 },
        { id: "whats-in-out", value: "What In-Out", open: false, items: {}, isPaginate: 1 },
        { id: "scheme-return-ranks", value: "Scheme Return Ranks", open: false, items: {}, isPaginate: 0 },
        { id: "scheme-rolling-returns", value: "Scheme Rolling Returns", open: false, items: {}, isPaginate: 0 },
      ],
      rawDataType: "basic",//"scheme-holdings",
      rawDataApi: "mutual-funds/",
      rawData: [],
      durDateList: [],
      schemeHoldingsPercHold: 0,
      analysisPercHold: 0,
      isDownload: 0,
      selectedDurDate: [],
      valueGrowthData: [],
      sum: {},
      fillableData: [],
      selRowInd: 0,
      page: 1,
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: [],
      perPage: 200,
      analysisTableFields:
        [
          {
            title: 'CO_CODE',
            name: this.getLabel('CO_CODE'),
            isLink: 0,
            datatype: '',
            sort_order: 1
          },
          {
            title: 'CO_NAME',
            name: this.getLabel('CO_NAME'),
            isLink: 0,
            datatype: '',
            sort_order: 2
          }, {
            title: 'bsegroup',
            name: this.getLabel('bsegroup'),
            isLink: 0,
            datatype: '',
            sort_order: 3
          }, {
            title: 'bsecode',
            name: this.getLabel('bsecode'),
            isLink: 0,
            datatype: '',
            sort_order: 4
          }, {
            title: 'nsesymbol',
            name: this.getLabel('nsesymbol'),
            isLink: 0,
            datatype: '',
            sort_order: 5
          }, {
            title: 'industrycode',
            name: this.getLabel('industrycode'),
            isLink: 0,
            datatype: '',
            sort_order: 6
          }, {
            title: 'industryname',
            name: this.getLabel('industryname'),
            isLink: 0,
            datatype: '',
            sort_order: 7
          }, {
            title: 'sectorname',
            name: this.getLabel('sectorname'),
            isLink: 0,
            datatype: '',
            sort_order: 8
          }, {
            title: 'govtflag',
            name: this.getLabel('govtflag'),
            isLink: 0,
            datatype: '',
            sort_order: 9
          },
          {
            title: '1_year_return',
            name: this.getLabel('1Yr_return'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 10
          },
          {
            title: 'PERC_HOLD',
            name: this.getLabel('PERC_HOLD'),
            isLink: 0,
            datatype: '',
            sort_order: 10
          },
          {
            title: 'mcaptype',
            name: this.getLabel('mcaptype'),
            isLink: 0,
            datatype: '',
            sort_order: 10
          },
          {
            title: 'market_capitalization',
            name: this.getLabel('market_capitalization'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 11
          },
          {
            title: 'Rating',
            name: this.getLabel('Rating'),
            isLink: 0,
            datatype: '',
            sort_order: 12
          },
          {
            title: 'RatingAgency',
            name: this.getLabel('RatingAgency'),
            isLink: 0,
            datatype: '',
            sort_order: 13
          },
          {
            title: 'p1_S',
            name: this.getLabel('p1_S'),
            isLink: 0,
            datatype: '',
            sort_order: 14
          },
          {
            title: 'p1_S_%_hldg',
            name: this.getLabel('p1_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 13
          },
          {
            title: 'p2_S',
            name: this.getLabel('p2_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 14
          },
          {
            title: 'p2_S_%_hldg',
            name: this.getLabel('p2_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 15
          },
          {
            title: 'p3_S',
            name: this.getLabel('p3_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 16
          },
          {
            title: 'p3_S_%_hldg',
            name: this.getLabel('p3S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 17
          },
          {
            title: 'p4_S',
            name: this.getLabel('p4_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 18
          },
          {
            title: 'p4_S_%_hldg',
            name: this.getLabel('p4_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 19
          },
          {
            title: 'p5_a_S',
            name: this.getLabel('p5_a_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 20
          },
          {
            title: 'p5_a_S_%_hldg',
            name: this.getLabel('p5_a_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 20
          },
          {
            title: 'p5_b_S',
            name: this.getLabel('p5_b_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 21
          },
          {
            title: 'p5_b_S_%_hldg',
            name: this.getLabel('p5_b_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 21
          },
          {
            title: 'p6_a',
            name: this.getLabel('p6_a'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 22
          },
          {
            title: 'p6_a_%_hldg',
            name: this.getLabel('p6_a_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 23
          },
          {
            title: 'p7_a_S',
            name: this.getLabel('p7_a_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 24
          },
          {
            title: 'p7_a_S_%_hldg',
            name: this.getLabel('p7_a_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 25
          },
          {
            title: 'p7_b_S',
            name: this.getLabel('p7_b_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 26
          },
          {
            title: 'p7_b_S_%_hldg',
            name: this.getLabel('p7_b_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 27
          },
          {
            title: 'p8_a_S',
            name: this.getLabel('p8_a_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 28
          },
          {
            title: 'p8_a_S_%_hldg',
            name: this.getLabel('p8_a_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 29
          },
          {
            title: 'p8_b_S',
            name: this.getLabel('p8_b_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 30
          },
          {
            title: 'p8_b_S_%_hldg',
            name: this.getLabel('p8_b_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 31
          },
          {
            title: 'p9_S',
            name: this.getLabel('p9_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 32
          },
          {
            title: 'p9_S_%_hldg',
            name: this.getLabel('p9_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 33
          },
          {
            title: 'p10_S',
            name: this.getLabel('p10_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 19
          },
          {
            title: 'p10_S_%_hldg',
            name: this.getLabel('p10_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 34
          },
          {
            title: 'p11_debt_rating',
            name: this.getLabel('p11_debt_rating'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 35
          },
          {
            title: 'p11_debt_%_hldg',
            name: this.getLabel('p11_debt_rating_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 35
          },
          {
            title: 'p11_rating',
            name: this.getLabel('p11_rating'),
            isLink: 0,
            datatype: 'rating',
            sort_order: 35
          },
          {
            title: 'p11_S',
            name: this.getLabel('p11_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 35
          },
          {
            title: 'p11_S_%_hldg',
            name: this.getLabel('p11_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 36
          },
          {
            title: 'p11_quarterly_trends_rating',
            name: this.getLabel('p11_quarterly_trends_rating'),
            isLink: 0,
            datatype: 'rating',
            sort_order: 37
          },
          {
            title: 'p11_quarterly_trends',
            name: this.getLabel('p11_quarterly_trends'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 37
          },
          {
            title: 'p11_quarterly_trends_%_hldg',
            name: this.getLabel('p11_quarterly_trends_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 38
          },
          {
            title: 'q1_S',
            name: this.getLabel('q1_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 39
          },
          {
            title: 'q1_S_%_hldg',
            name: this.getLabel('q1_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 40
          },
          {
            title: 'q1_a_S',
            name: this.getLabel('q1_a_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 41
          },
          {
            title: 'q1_a_S_%_hldg',
            name: this.getLabel('q1_a_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 42
          },
          {
            title: 'q1_b_S',
            name: this.getLabel('q1_b_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 43
          },
          {
            title: 'q1_b_S_%_hldg',
            name: this.getLabel('q1_b_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 44
          },
          {
            title: 'q1_a_or_b_greater_rating',
            name: this.getLabel('q1_a_or_b_greater_rating'),
            isLink: 0,
            datatype: 'rating',
            sort_order: 45
          },
          {
            title: 'q1_a_b_greater',
            name: this.getLabel('q1_a_b_greater'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 45
          },
          {
            title: 'q1_a_b_greater_%_hldg',
            name: this.getLabel('q1_a_b_greater_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 46
          },
          {
            title: 'q1_c_S',
            name: this.getLabel('q1_c_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 47
          },
          {
            title: 'q1_c_S_%_hldg',
            name: this.getLabel('q1_c_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 48
          },
          {
            title: 'q1_d_S',
            name: this.getLabel('q1_d_S'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 49
          },
          {
            title: 'q1_d_S_%_hldg',
            name: this.getLabel('q1_d_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 50
          },
        ],
      analysisSumTableFields: [
        {
          title: 'mf_schcode',
          name: this.getLabel('mf_schcode'),
          isLink: 0,
          datatype: '',
          sort_order: 1,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'date',
          name: this.getLabel('date'),
          isLink: 0,
          datatype: 'date',
          sort_order: 2,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'MF_COCODE',
          name: this.getLabel('MF_COCODE'),
          isLink: 0,
          datatype: '',
          sort_order: 3,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'LNAME',
          name: this.getLabel('LNAME'),
          isLink: 0,
          datatype: '',
          sort_order: 4,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'sch_name',
          name: this.getLabel('sch_name'),
          isLink: 0,
          datatype: '',
          sort_order: 5,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'Category',
          name: this.getLabel('Category'),
          isLink: 0,
          datatype: '',
          sort_order: 6,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'FundManager',
          name: this.getLabel('FundManager'),
          isLink: 0,
          datatype: '',
          sort_order: 7,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'scheme_ratios_date',
          name: this.getLabel('scheme_ratios_date'),
          isLink: 0,
          datatype: 'date',
          sort_order: 8,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'ALPHA',
          name: this.getLabel('ALPHA'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 9,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'BETA',
          name: this.getLabel('BETA'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 10,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'AVERAGE',
          name: this.getLabel('AVERAGE'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 11,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'NAV',
          name: this.getLabel('NAV'),
          isLink: 0,
          datatype: '',
          sort_order: 12,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'RSQUARE',
          name: this.getLabel('RSQUARE'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 13,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'SD',
          name: this.getLabel('SD'),
          isLink: 0,
          datatype: '',
          sort_order: 14,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'SHARPE',
          name: this.getLabel('SHARPE'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 15,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'scheme_returns_date',
          name: this.getLabel('returns_date'),
          isLink: 0,
          datatype: 'date',
          sort_order: 16,
          sort: 0,
          isSortable: 1
        },
        {
          title: '1month',
          name: this.getLabel('1 M'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 17,
          sort: 0,
          isSortable: 1
        },
        {
          title: '3month',
          name: this.getLabel('3 M'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 18,
          sort: 0,
          isSortable: 1
        },
        {
          title: '6month',
          name: this.getLabel('6 M'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 19,
          sort: 0,
          isSortable: 1
        },
        {
          title: '1year',
          name: this.getLabel('1 Yr'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 20,
          sort: 0,
          isSortable: 1
        },
        {
          title: '3year',
          name: this.getLabel('3 Yrs'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 21,
          sort: 0,
          isSortable: 1
        },
        {
          title: '5year',
          name: this.getLabel('5 Yrs'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 22,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'inception',
          name: this.getLabel('inception'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 23,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'EXPRATIO',
          name: this.getLabel('Exp Ratio'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 24,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p1_S_%_hldg',
          name: this.getLabel('p1_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 25,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p2_S_%_hldg',
          name: this.getLabel('p2_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 26,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p3_S_%_hldg',
          name: this.getLabel('p3S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 26,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p4_S_%_hldg',
          name: this.getLabel('p4_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 27,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p5_a_S_%_hldg',
          name: this.getLabel('p5_a_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 28,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p5_b_S_%_hldg',
          name: this.getLabel('p5_b_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 29,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p6_a_%_hldg',
          name: this.getLabel('p6_a_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 30,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p7_a_S_%_hldg',
          name: this.getLabel('p7_a_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 31,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p7_b_S_%_hldg',
          name: this.getLabel('p7_b_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 32,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p8_a_S_%_hldg',
          name: this.getLabel('p8_a_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 33,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p8_b_S_%_hldg',
          name: this.getLabel('p8_b_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 34,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p9_S_%_hldg',
          name: this.getLabel('p9_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 35,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p10_S_%_hldg',
          name: this.getLabel('p10_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 36,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p11_debt_%_hldg',
          name: this.getLabel('p11_debt_rating_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 35
        },
        {
          title: 'p11_S_%_hldg',
          name: this.getLabel('p11_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 37,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p11_quarterly_trends_%_hldg',
          name: this.getLabel('p11_quarterly_trends_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 38,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'q1_S_%_hldg',
          name: this.getLabel('q1_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 40,
          sort: 0,
          isSortable: 1
        },
        // {
        //   title: 'q1_a_greater',
        //   name: this.getLabel('q1_a_greater'),
        //   isLink: 0,
        //   datatype: 'numeric',
        //   sort_order: 41,
        //   sort: 0,
        //   isSortable: 1
        // },
        // {
        //   title: 'q1_b_greater',
        //   name: this.getLabel('q1_b_greater'),
        //   isLink: 0,
        //   datatype: 'numeric',
        //   sort_order: 41,
        //   sort: 0,
        //   isSortable: 1
        // },
        {
          title: 'q1_a_S_%_hldg',
          name: this.getLabel('q1_a_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 42,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'q1_b_S_%_hldg',
          name: this.getLabel('q1_b_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 44,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'q1_a_b_greater_%_hldg',
          name: this.getLabel('q1_a_b_greater_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 46,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'q1_c_S_%_hldg',
          name: this.getLabel('q1_c_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 48,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'q1_d_S_%_hldg',
          name: this.getLabel('q1_d_S_%_hldg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 50,
          sort: 0,
          isSortable: 1
        }
      ],
      ratings:
      {
        title: 'ratings',
        name: 'Ratings',
        datatype: 'numeric',
        sort_order: 51,
        sort: 0,
        isSortable: 1,
        subFields: []
      },
      industryKeys: [
        { title: 'name', name: 'Sector' },
        { title: 'value', name: '% Holding' }
      ],
      typewiseKeys: [
        { title: 'name', name: 'Type' },
        { title: 'value', name: '% Holding' },
        { title: 'holdCount', name: 'Count' },
      ],
      mcapKeys: [],
      psumratingwiseKeys: [],
      top3exposuresKeys: [],
      top3industryKeys: [],
      businessRatings: [],
      businessRatingKeys: [7, 6, 5, 4, 3, 2, 1],
      valuationRatingKeys: [5, 4, 3, 2, 1],
      valuationRatings: [],
      qtrRatingKeys: [5, 4, 3, 2, 1],
      qtrRatings: [],
      debtRatingKeys: [7, 6, 5, 4, 3, 2, 1],
      debtRatings: [],
      crRatingKeys: [
        {
          title: 'name',
          name: this.getLabel('name'),
          isLink: 0,
          datatype: 'string',
          sort_order: 2,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'PERC_HOLD',
          name: this.getLabel('% Hold'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 3,
          sort: 0,
          isSortable: 1
        },
      ],
      creditRatingsKeys: [
        {
          title: 'type',
          name: 'Type',
          isLink: 0,
          datatype: 'string',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'name',
          name: this.getLabel('name'),
          isLink: 0,
          datatype: 'string',
          sort_order: 2,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'PERC_HOLD',
          name: this.getLabel('% Hold'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 3,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p11_S_%_hldg',
          name: this.getLabel('business_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 4,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p11_S_%_hldg_adj',
          name: this.getLabel('adj_business_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 7,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'q1_a_b_greater_%_hldg',
          name: this.getLabel('valuation_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 5,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'q1_a_b_greater_%_hldg_adj',
          name: this.getLabel('adj_valuation_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 8,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p11_quarterly_trends_%_hldg',
          name: this.getLabel('quarterly_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 6,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p11_quarterly_trends_%_hldg_adj',
          name: this.getLabel('adj_quarterly_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 9,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p11_debt_%_hldg',
          name: this.getLabel('Debt_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 6,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p11_debt_%_hldg_adj',
          name: this.getLabel('adj_debt_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 9,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'overall_rating',
          name: this.getLabel('Overall Rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 10,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'overall_rating_adj',
          name: this.getLabel('adj_overall_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 11,
          sort: 0,
          isSortable: 1
        }
      ],
      overallRatingKeys: [
        {
          title: 'overall_business_rating',
          name: 'Business Rating',
          isLink: 0,
          datatype: 'numeric',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'overall_valuation_rating',
          name: 'Valuation Rating',
          isLink: 0,
          datatype: 'numeric',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'overall_quarterly_rating',
          name: 'Quarterly Rating',
          isLink: 0,
          datatype: 'numeric',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'overall_debt_others_rating',
          name: 'Debt & Others Rating',
          isLink: 0,
          datatype: 'numeric',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'overall_equity_rating',
          name: 'Equity Rating',
          isLink: 0,
          datatype: 'numeric',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'overall_scheme_rating',
          name: 'Scheme Rating',
          isLink: 0,
          datatype: 'numeric',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'overall_weighted_scheme_rating',
          name: 'Weighted Scheme Rating',
          isLink: 0,
          datatype: 'numeric',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
      ],
      whatsIn: [],
      whatsOut: [],
      showWhatsIn: true
    };
  },
  computed: {
    getPercentHoldingTotal: function () {
      let total = 0;
      for (const [key, value] of Object.entries(this.rawData.holdings_summary.credit_ratings)) {
        total += value['PERC_HOLD'];
      }
      return total;
    }

    // mfHoldingData: function() {
    //   return this.rawData.filter(function(row, index) {
    //     return index !== "_id" && index !== "co_code";
    //   });
    // },
    // keyFinancialRatios: function(){
    //   return (this.rawData.length > 0 && this.rawData[0]['keyfinancialratiolist'])? this.rawData[0]['keyfinancialratiolist']: [];
    // }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}

.table td {
  padding: 5px 10px 5px 10px;
}

span.success,
td span.success {
  color: #28a745;
}

span.error,
td span.error {
  color: #dc3545;
}

.right-panel.fHeight {
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/views/mutual-funds/scheme-master.vue